<script>
import Multiselect from "@vueform/multiselect";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import Loader from "../components/loader";
import api from "@/axios";
import moment from "moment/moment";
import { driver } from "driver.js"
import "driver.js/dist/driver.css"
import {getBaseUrl} from "@/helpers/baseUrl";


export default {
  page: {
    title: "Cotar Frete",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Loader, Multiselect },
  setup() {

  },
  data() {
    return {
      tempoCotacao: null,
      tempoCotacaoExt: null,

      showModalCotDemanda: false,
      freteCotaCalcDemsData: null,
      limiteCotaDem: null,
      userPct: null,

      tipoFrete: 'CIF',
      showModalOrigem: false,
      emprOrigensData: null,

      showModalCotacaoApi: false,
      cotacaoIntExtApi: [],

      dominioMigrouCalc: false,
      correiosServData: null,
      dtListPesqCorreioServico: null,

      visibleAc2: true,
      visibleAc3: true,
      visibleAc4: true,
      updatingCotaExt: false,
      updatingCotaInt: false,
      showModalCotaInt: false,
      cotaFreteData: {
        tipoPessoa: 'PJ'
      },
      empresaData: {},

      totalLarg: 0.00,
      totalAlt: 0.00,
      totalComp: 0.00,
      totalQuant: 0.00,
      totalMCub: 0.00,
      freteCotaCalcsData: null,
      freteCotaCalcExtsData: null,
      freteCotaCalcAdicsData: null,
      freteCotaCalcAdicsFiltData: null,

      userLogged: {},
      errosCotacao: null,
      cotaFrtResults: null,
      falhasCotacao: [],
      jsonModalData: null,
      showModalJson: false,

      showModalCotarFrete: false,
      loadingCotarFrete: false,
      loadingCnpj: false,
      loadingCidOri: false,
      loadingCidDest: false,
      dtListPesqSegto: null,
      showModalVolume: false,
      cotaFrtVolume: {},
      cotaFrtVolumes: [],
      submittedVolume: false,
      seguimentoData: null,

      verificaCliente: true,
      identClient: null,

      cotacaoDataSelected:[],

      updating: true,
      errosValid: null,
      cotacaoData: {
        id: 0,
        status: 'AB',
        tipo: 'manual'
      },


      idData: 0,
      submitted: false,

      title: "Cotar Frete",
      items: [
        {
          text: "Cotações",
          href: "/cotafrts/listnova",
        },
        {
          text: "Cotar Frete",
          active: true,
        },
      ],
      qtdVols: 0,
      dtListPesqEmpresa: [],

      // Campos de cotacaoData que alimentam o cálculo do frete. Alterar qualquer
      // um deles invalida o cálculo já realizado.
      camposCalculo: [
        'segto', 'cnpj',
        'cepori', 'cidori', 'nroori',
        'cepdest', 'ciddest',
        'dtcoleta',
        'valornf', 'peso', 'qtdvol', 'dimens'
      ],
      // Último valor conhecido de cada campo acima, usado para desfazer a
      // alteração quando o usuário não confirma a exclusão do cálculo.
      valoresAntesEdicao: {},
    };
  },

  computed: {
    maskCnpjCpf() {

      return this.cotacaoData.tipoPessoa === 'PJ' || !this.cotacaoData.tipoPessoa ? "##.###.###/####-##" : "###.###.###-##";
    },

    // Transportadora já escolhida: a tela passa a ser somente leitura (campos apenas exibidos)
    transpEscolhida() {
      return this.cotacaoData.cotaid > 0
    },

    // Campos bloqueados quando a cotação não está mais em aberto ou a transportadora
    // já foi escolhida. Data e observação de coleta ficam fora deste bloqueio: são
    // dados de agendamento e podem ser alterados em qualquer situação da cotação.
    camposBloqueados() {
      return this.transpEscolhida || this.cotacaoData.status !== 'AB'
    }
  },

  methods: {

    // Guarda o valor atual dos campos que alimentam o cálculo, para poder
    // desfazer a alteração caso o usuário não confirme a exclusão do cálculo.
    snapshotCamposCalculo() {
      const snapshot = {}
      this.camposCalculo.forEach((campo) => {
        snapshot[campo] = this.cotacaoData ? this.cotacaoData[campo] : null
      })
      this.valoresAntesEdicao = snapshot
    },

    // O cotaid sempre aponta para uma linha de cálculo (interna ou externa) da
    // própria cotação. Uma cotação recém-copiada herda os dados da escolha da
    // origem sem herdar os cálculos, o que deixaria a tela bloqueada em somente
    // leitura sem existir cotação calculada. Nesse caso a escolha é descartada.
    limparEscolhaTranspOrfa() {
      if (!this.cotacaoData || !(this.cotacaoData.cotaid > 0)) {
        return
      }

      const calculos = [
        ...(this.freteCotaCalcsData || []),
        ...(this.freteCotaCalcExtsData || [])
      ]
      const escolhaValida = calculos.some(
          (calc) => parseInt(calc.id) === parseInt(this.cotacaoData.cotaid)
      )

      if (escolhaValida) {
        return
      }

      console.log('escolha de transportadora sem cálculo correspondente, descartando')
      this.cotacaoData.cotaid = null
      this.cotacaoData.nometransp = ''
      this.cotacaoData.cnpjtransp = null
      this.cotacaoData.valorfrete = null
      this.cotacaoData.pesofrete = null
      this.cotacaoData.percfrete = null
      this.cotacaoData.prazo = null
      this.cotacaoData.dtcontr = null
      this.cotacaoDataSelected = []
    },

    existeCalculoCotacao() {
      return (this.freteCotaCalcsData && this.freteCotaCalcsData.length > 0)
          || (this.freteCotaCalcExtsData && this.freteCotaCalcExtsData.length > 0)
          || (this.cotaFrtResults && this.cotaFrtResults.length > 0)
    },

    limparCalculoLocal() {
      this.freteCotaCalcsData = []
      this.freteCotaCalcExtsData = []
      this.freteCotaCalcAdicsData = []
      this.freteCotaCalcAdicsFiltData = null
      this.cotaFrtResults = []
      this.cotacaoIntExtApi = []
      this.falhasCotacao = []
      this.errosCotacao = null
      this.tempoCotacao = null
      this.tempoCotacaoExt = null
    },

    excluirCalculoCotacao() {
      console.log('excluirCalculoCotacao')
      if (!this.idData || this.idData === 0) {
        this.limparCalculoLocal()
        return Promise.resolve()
      }
      return api.delete(`${getBaseUrl()}api/cotafrtcalc`, {
        params: {iddata: this.idData}
      }).then((res) => {
        console.log('then axios delete calc')
        console.log(res.data)
        this.limparCalculoLocal()
      })
    },

    // Pergunta ao usuário e, se confirmado, exclui o cálculo.
    // Resolve com true quando o cálculo foi excluído e false quando cancelado.
    confirmarExclusaoCalculo() {
      return Swal.fire({
        position: "center",
        icon: "warning",
        title: "Cálculo da cotação será excluído",
        text: "Esta alteração invalida o cálculo já realizado. Ao confirmar, o cálculo será excluído e será necessário cotar o frete novamente.",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then((result) => {
        if (!result.value) {
          return false
        }
        return this.excluirCalculoCotacao().then(() => true)
      })
    },

    // Os campos numéricos chegam da API como texto ("1000.00") e viram número
    // pelo v-model, então a comparação bruta acusaria alteração inexistente.
    mesmoValorCampo(campo, atual, anterior) {
      if (atual === anterior) {
        return true
      }
      if ((atual === null || atual === undefined || atual === '')
          && (anterior === null || anterior === undefined || anterior === '')) {
        return true
      }
      if (['valornf', 'peso', 'qtdvol', 'dimens'].includes(campo)) {
        return parseFloat(atual) === parseFloat(anterior)
      }
      return false
    },

    // Chamado no @change dos campos que alimentam o cálculo. Sem cálculo
    // existente segue normalmente; com cálculo, pede confirmação e desfaz a
    // alteração caso o usuário cancele.
    alterouCampoCotacao(campo, aposConfirmar) {
      const anterior = this.valoresAntesEdicao[campo]

      if (!this.existeCalculoCotacao()
          || this.mesmoValorCampo(campo, this.cotacaoData[campo], anterior)) {
        this.valoresAntesEdicao[campo] = this.cotacaoData[campo]
        if (aposConfirmar) {
          aposConfirmar()
        }
        return
      }

      this.confirmarExclusaoCalculo().then((confirmou) => {
        if (confirmou) {
          this.valoresAntesEdicao[campo] = this.cotacaoData[campo]
          if (aposConfirmar) {
            aposConfirmar()
          }
        } else {
          this.cotacaoData[campo] = anterior
        }
      })
    },

    // A data de coleta alimenta a cotação externa enquanto a cotação está em
    // aberto, então continua invalidando o cálculo nesse caso. Com a cotação
    // bloqueada (transportadora escolhida ou cotação fora de aberto) ela passa a
    // ser apenas agendamento e pode ser alterada sem mexer no cálculo.
    alterouDtColeta() {
      if (this.camposBloqueados) {
        this.valoresAntesEdicao['dtcoleta'] = this.cotacaoData.dtcoleta
        return
      }
      this.alterouCampoCotacao('dtcoleta')
    },

    // Para ações (botões) que alteram em lote os dados usados no cálculo.
    executarComCalculo(acao) {
      if (!this.existeCalculoCotacao()) {
        acao()
        return
      }
      this.confirmarExclusaoCalculo().then((confirmou) => {
        if (confirmou) {
          acao()
        }
      })
    },

    escolheuEmpresa(evt){
      console.log("escolheuEmpresa")
      //console.log("codigo empresa: " + evt)
      this.cotacaoData.segto = null

      this.empresaData = this.dtListPesqEmpresa.find(item => evt === item.codigo)
      //console.log(`empresaData updated: ${JSON.stringify(this.empresaData)}`)

      if(this.empresaData?.fretecota){
        //console.log("atualizando fretecota")
        this.cotacaoData.segto = this.empresaData?.fretecota ?? null
      }
      this.snapshotCamposCalculo()

      if(this.empresaData?.fretecota){
        //console.log("atualizando segmento")
        api.get(`${getBaseUrl()}api/pesqfretecotaempr`, {
          params: {q: this.cotacaoData.segto, e: this.cotacaoData.empresa}
        }).then((res) => {
          console.log('then axios update fretecota')
          console.log(res.data)
          this.dtListPesqSegto = res.data
        })
      }
    },

    pesqEmpresa(evt){
      console.log('pesqEmpresa')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/emprepesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(JSON.stringify(res.data))

          this.dtListPesqEmpresa = res.data
        })
      }
    },

    enviarSoliCota(){
      console.log('enviarSoliCota')
      this.loadingCotarFrete = true


      api.post(`${getBaseUrl()}api/cotafrtdemenv`, {
        iddata: this.idData,
        limite: this.limiteCotaDem
      }).then((res) => {
        console.log('then axios')
        console.log(res)
        this.loadingCotarFrete = false
        this.freteCotaCalcDemsData = res.data[0]
      })

    },



    deletarCotaDem(dataID) {
      console.log('deletarCotaDem')
      this.loadingCotarFrete = true
      api.delete(`${getBaseUrl()}api/cotafrtdem`, {
        params: {
          'iddata': dataID
        }
      }).then((res) => {
        console.log('then axios')
        console.log(res)
        this.loadingCotarFrete = false
        this.freteCotaCalcDemsData = res.data[0]
      })
    },


    cotacaoDemanda(){
      console.log('cotacaoDemanda')
      console.log(this.freteCotaCalcDemsData)
      this.loadingCotarFrete = true
      this.showModalCotDemanda = true
      api.post(`${getBaseUrl()}api/cotafrtdem`, {
        iddata: this.idData
      }).then((res) => {
        console.log('then axios')
        console.log(res)
        this.loadingCotarFrete = false
        this.freteCotaCalcDemsData = res.data[0]
      })
    },


    ajuda(){
      console.log('ajuda')
      const driverObj = driver({
        showProgress: true,
        nextBtnText: 'Próximo >',
        prevBtnText: '< Anterior',
        doneBtnText: 'Finalizar',
        steps: [
          { element: '#bCardOriDest', popover: { title: 'Origem e Destino', description: 'Os dados de origem serão importados do cadastro de sua empresa e os dados de destino deverão ser inseridos manualmente.' } },
          { element: '#btnSalvar', popover: { title: 'Salvar Alterações', description: 'Após preencher clicar em salvar as funções adicionais como cotação irão aparecer.' } },
          { element: '#bCardInfoMerc', popover: { title: 'Informações Mercadoria', description: 'Não deixar de preencher os valores excenciais para cotação, como valor de nota fiscal e peso.' } },
        ]
      })
      driverObj.drive()
    },


    upgradePlano(){
      console.log('upgradePlano')
    },


    alteraTipoFrete(){
      console.log('alteraTipoFrete')

      const cepori = this.cotacaoData.cepori
      const logrori = this.cotacaoData.logrori
      const complori = this.cotacaoData.complori
      const bairroori = this.cotacaoData.bairroori
      const cidori = this.cotacaoData.cidori
      const ufori = this.cotacaoData.ufori
      const nroori = this.cotacaoData.nroori

      const cepdest = this.cotacaoData.cepdest
      const logrdest = this.cotacaoData.logrdest
      const compldest = this.cotacaoData.compldest
      const bairrodest = this.cotacaoData.bairrodest
      const ciddest = this.cotacaoData.ciddest
      const ufdest = this.cotacaoData.ufdest
      const nrodest = this.cotacaoData.nrodest

      this.cotacaoData.cepori = cepdest
      this.cotacaoData.logrori = logrdest
      this.cotacaoData.complori = compldest
      this.cotacaoData.bairroori = bairrodest
      this.cotacaoData.cidori = ciddest
      this.cotacaoData.ufori = ufdest
      this.cotacaoData.nroori = nrodest

      this.cotacaoData.cepdest = cepori
      this.cotacaoData.logrdest = logrori
      this.cotacaoData.compldest = complori
      this.cotacaoData.bairrodest = bairroori
      this.cotacaoData.ciddest = cidori
      this.cotacaoData.ufdest = ufori
      this.cotacaoData.nrodest = nroori

      if (this.tipoFrete === 'CIF') {
        this.tipoFrete = 'FOB'
      } else {
        this.tipoFrete = 'CIF'
      }
      this.snapshotCamposCalculo()
      this.formSubmit()
    },

    escolherEmprOrigem(emprOrigem){
      console.log('escolherEmprOrigem')
      console.log(emprOrigem)
      this.showModalOrigem = false
      this.executarComCalculo(() => this.aplicarEmprOrigem(emprOrigem))
    },

    aplicarEmprOrigem(emprOrigem){
      if (emprOrigem.cep) {
        this.cotacaoData.cepori = emprOrigem.cep
      }
      if (emprOrigem.bairro) {
        this.cotacaoData.bairroori = emprOrigem.bairro
      }
      if (emprOrigem.compl) {
        this.cotacaoData.complori = emprOrigem.compl
      }
      if (emprOrigem.cidade) {
        this.cotacaoData.cidori = emprOrigem.cidade
      }
      if (emprOrigem.estado) {
        this.cotacaoData.ufori = emprOrigem.estado
      }
      if (emprOrigem.numero) {
        this.cotacaoData.nroori = emprOrigem.numero
      }
      if (emprOrigem.rua) {
        this.cotacaoData.logrori = emprOrigem.rua
      }
      this.snapshotCamposCalculo()
    },

    abrirTabela(idTabela) {
      console.log('abrirTabela')
      this.showModalCotaInt = false
      const routeData = this.$router.resolve(`/cotacaofretesbase/editar/${idTabela}`)
      window.open(routeData.href, '_blank')
    },


    pesqCorreioServico(evt) {
      console.log('pesqCorreioServico')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1) {
        this.loadingTransp = true
        api.get(`${getBaseUrl()}api/corservpesq`, {
          params: {q: query, emp: this.cotacaoData.empresa}
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqCorreioServico = res.data
        })
      }
    },


    nomeStatus(strEntr) {
      let result = 'Não Definido'
      switch (strEntr) {
        case 'AB':
          result = 'Aberto'
          break
        case 'CO':
          result = 'Contratado'
          break
        case 'X':
          result = 'Cancelado'
          break
      }
      return result
    },

    nomeStatusCotaDem(strEntr) {
      let result = 'Não Definido'
      switch (strEntr) {
        case 'NE':
          result = 'Não Enviado'
          break
        case 'EV':
          result = 'Enviado'
          break
        case 'CO':
          result = 'Contratado'
          break
        case 'X':
          result = 'Cancelado'
          break
      }
      return result
    },

    contratar(dataId) {
      console.log('contratar')
      console.log(dataId)
      Swal.fire({
        position: "center",
        icon: "question",
        title: `Contratação de Cotação ${dataId}`,
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        console.log('resultContratar')
        console.log(result)
        if (result.value) {
          this.updating = true
          api.post(`${getBaseUrl()}api/cotafrtcontrint`, {
            iddata: dataId
          }).then((res) => {
            console.log('then axios')
            console.log(res)
            
            
            Swal.fire({
              position: "top-end",
              icon: res.data[0] === "erro" ? "error" : "success",
              title: res.data[0] === "erro" ? res.data[1] : "Frete contratado com sucesso!",
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              this.carregarDados()
              const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')
              WinPrint.document.write(res.data[1])
              WinPrint.document.close()
              WinPrint.focus()
              WinPrint.print()
              WinPrint.close()
            })
          })
        }
      })
    },


    abrirCotaInt(dataRow) {
      console.log('abrirCotaInt_0')
      console.log(dataRow)
      this.showModalCotaInt = true
      this.cotaFreteData = dataRow
      // console.log('this.freteCotaCalcAdicsData')
      let adicsDaCota = []
      if (this.freteCotaCalcAdicsData){
        this.freteCotaCalcAdicsData.forEach((value) => {
          // console.log(value.fretecotacalc_id)
          if (value.fretecotacalc_id === dataRow.id) {
            adicsDaCota.push(value)
          }
        })
        this.freteCotaCalcAdicsFiltData = adicsDaCota
      }
    },


    getImgUrl(cnpj) {
      // console.log('getImgUrl');
      // console.log(cnpj);
      try {
        let fileName = require('@/assets/images/logotransp/' + cnpj + '.png');
        // console.log("file found");
        return fileName
      } catch (e) {
        let fileName2 = require('@/assets/images/logotransp/sem_logo.png');
        // console.log("sorry, file not found");
        return fileName2
      }
    },

    imagePath: function (cnpjTransp) {
      return require('@/assets/images/logotransp/' + cnpjTransp + '.png')
    },


    cotacaoselected(dataFrete) {

      console.log('cotação selecionada')
      console.log(dataFrete)
      this.showModalCotacaoApi = false
      this.showModalCotarFrete = false
      this.updating = true

      this.cotacaoData.cnpjtransp = dataFrete.transpcnpj
      // this.cotacaoData.mailtransp = dataFrete.WSOut_Transp_Email
      this.cotacaoData.nometransp = dataFrete.transpnome
      this.cotacaoData.cotaid = dataFrete.id
      this.cotacaoData.prazo = dataFrete.prazo
      this.cotacaoData.valorfrete = dataFrete.vlrtotalcicms
      this.cotacaoData.percfrete = dataFrete.vlrtotalcicms / this.cotacaoData.valornf * 100
      this.cotacaoData.pesofrete = dataFrete.vlrtotalcicms / this.cotacaoData.peso
      this.cotacaoData.dtcontr = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')

      api.post(`${getBaseUrl()}api/cotafrt`, {
        cotafrtData: this.cotacaoData
      }).then((res) => {
        console.log('then axios cotação selecionada:')
        console.log(res)

        if (res.data[0] === 'erro') {
          Swal.fire({
            position: "top-end",
            icon: "warning",
            title: "Erro: " + res.data[1],
            showConfirmButton: false,
            timer: 2500
          })
        } else {

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Frete Escolhido com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
        }
        this.cotacaoIntExtApi = [];
        this.carregarDados()
      })
    },

    escolherFrete(dataFrete) {
      console.log('escolherFrete_00')
      console.log(dataFrete)
      this.showModalCotarFrete = false
      this.updating = true

      this.cotacaoData.cnpjtransp = dataFrete.transpcnpj
      // this.cotacaoData.mailtransp = dataFrete.WSOut_Transp_Email
      this.cotacaoData.nometransp = dataFrete.transpnome
      this.cotacaoData.cotaid = dataFrete.id
      this.cotacaoData.prazo = dataFrete.prazo
      this.cotacaoData.valorfrete = dataFrete.vlrtotalcicms
      this.cotacaoData.percfrete = dataFrete.vlrtotalcicms / this.cotacaoData.valornf * 100
      this.cotacaoData.pesofrete = dataFrete.vlrtotalcicms / this.cotacaoData.peso

      api.post(`${getBaseUrl()}api/cotafrt`, {
        cotafrtData: this.cotacaoData
      }).then((res) => {
        console.log('then axios escolherFrete')
        console.log(res)

        this.updating = false

        if (res.data[0] === 'erro') {
          Swal.fire({
            position: "top-end",
            icon: "warning",
            title: "Erro: " + res.data[1],
            showConfirmButton: false,
            timer: 2500
          })
        } else {
          this.carregarDados()

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Frete Escolhido com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
          //     .then(() =>{
          //   const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')
          //   WinPrint.document.write(res.data[1])
          //   WinPrint.document.close()
          //   WinPrint.focus()
          //   WinPrint.print()
          //   WinPrint.close()
          // })
        }
      })
    },

    enviaCotacao() {
      console.log('enviando Cotacao')
      this.updating = true

      api.post(`${getBaseUrl()}api/cotafrtesc`, {
        cotafrtData: this.cotacaoData
      }).then((res) => {

        console.log('then axios escolherFrete')
        console.log(res.data)

        this.updating = false

        if (res.data[0] === 'erro') {
          Swal.fire({
            position: "top-end",
            icon: "warning",
            title: "Erro: " + res.data[1],
            showConfirmButton: false,
            timer: 2500
          })
        } else {
          this.carregarDados()

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Frete contratado com sucesso!",
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')
            WinPrint.document.write(res.data[1])
            WinPrint.document.close()
            WinPrint.focus()
            WinPrint.print()
            WinPrint.close()
          })
        }
      })

    },

    cotarFreteExterno() {

      console.log('cotarFreteExterno')

      let mensErro = []
      if (!this.cotacaoData.dtcoleta) {
        mensErro.push("O campo data de coleta deve ser preenchido, favor corrigir.")
      }
      if (!this.cotacaoData.peso || this.cotacaoData.peso === 0) {
        mensErro.push("O campo peso deve ser maior que zero, favor corrigir.")
      }
      if (!this.cotacaoData.valornf || this.cotacaoData.valornf === 0) {
        mensErro.push("O campo valor nota fiscal deve ser maior que zero, favor corrigir.")
      }
      if (!this.cotacaoData.cnpj || this.cotacaoData.cnpj === '') {
        mensErro.push("O campo CNPJ / CPF do destinatário deve ser preenchido, favor corrigir.")
      }
      if (!this.cotacaoData.cepori || this.cotacaoData.cepori === '') {
        mensErro.push("O campo CEP de origem deve ser preenchido, favor corrigir.")
      }
      if (!this.cotacaoData.cepdest || this.cotacaoData.cepdest === '') {
        mensErro.push("O campo CEP de destino deve ser preenchido, favor corrigir.")
      }
      if (this.cotaFrtVolumes.length === 0 || !this.cotaFrtVolumes[0]['altura'] || this.cotaFrtVolumes[0]['altura'] === 0) {
        mensErro.push("O campo altura deve ser maior que zero, favor corrigir.")
      }
      if (this.cotaFrtVolumes.length === 0 || !this.cotaFrtVolumes[0]['largura'] || this.cotaFrtVolumes[0]['largura'] === 0) {
        mensErro.push("O campo largura deve ser maior que zero, favor corrigir.")
      }
      if (this.cotaFrtVolumes.length === 0 || !this.cotaFrtVolumes[0]['comprim'] || this.cotaFrtVolumes[0]['comprim'] === 0) {
        mensErro.push("O campo comprimento deve ser maior que zero, favor corrigir.")
      }
      if (this.cotaFrtVolumes.length === 0 || !this.cotaFrtVolumes[0]['pesocub'] || this.cotaFrtVolumes[0]['pesocub'] === 0) {
        mensErro.push("O campo peso cubado deve ser maior que zero, favor corrigir.")
      }
      if (mensErro.length > 0) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: mensErro,
          showConfirmButton: false,
          timer: 2500
        })
      } else {
        this.updatingCotaExt = true
        this.visibleAc2 = false
        this.visibleAc3 = false
        this.visibleAc4 = false
        this.freteCotaCalcExtsData = null
        api.post(`${getBaseUrl()}api/cotafrt`, {
          cotafrtData: this.cotacaoData
        }).then((resPost) => {
          console.log('then axios post')
          console.log(resPost)
          api.get(`${getBaseUrl()}api/cotarfrtmanuext`, {
            params: {iddata: this.idData}
          }).then((res) => {
            console.log('res cotarFreteExt_01')
            console.log(res.data)
            // console.log(res.data[0]['SDT_WSRetorno'])
            this.updatingCotaExt = false
            this.freteCotaCalcExtsData = res.data[0]

            // if (res.data[0]['erro']) {
            //   console.log(res.data[0]['erro'])
            //   this.errosCotacao = [{
            //     'Description': res.data[0]['erro']
            //   }]
            // } else {
            //   this.updatingCotaInt = false
            //   this.freteCotaCalcsData = res.data[0]
            //
            // }
          }).catch((err) => {
            console.log('erro axios')
            console.log(err)
          })
        })
      }
    },


    cotarFreteInterno() {
      console.log('cotarFreteInterno_0')

      let mensErro = []
      if (!this.cotacaoData.peso || this.cotacaoData.peso === 0) {
        mensErro.push("O campo peso deve ser maior que zero, favor corrigir.")
      }
      if (!this.cotacaoData.valornf || this.cotacaoData.valornf === 0) {
        mensErro.push("O campo valor nota fiscal deve ser maior que zero, favor corrigir.")
      }
      if (!this.cotacaoData.cnpj || this.cotacaoData.cnpj === '') {
        mensErro.push("O campo CNPJ / CPF do destinatário deve ser preenchido, favor corrigir.")
      }
      if (!this.cotacaoData.cepori || this.cotacaoData.cepori === '') {
        mensErro.push("O campo CEP de origem deve ser preenchido, favor corrigir.")
      }
      if (!this.cotacaoData.cepdest || this.cotacaoData.cepdest === '') {
        mensErro.push("O campo CEP de destino deve ser preenchido, favor corrigir.")
      }


      if (!this.cotacaoData.dimens && (this.cotaFrtVolumes.length === 0 || !this.cotaFrtVolumes[0]['altura'] || this.cotaFrtVolumes[0]['altura'] === 0)) {
        mensErro.push("O campo altura deve ser maior que zero ou preencha o total dimensões (m³), favor corrigir.")
      }
      if (!this.cotacaoData.dimens && (this.cotaFrtVolumes.length === 0 || !this.cotaFrtVolumes[0]['largura'] || this.cotaFrtVolumes[0]['largura'] === 0)) {
        mensErro.push("O campo largura deve ser maior que zero ou preencha o total dimensões (m³), favor corrigir.")
      }
      if (!this.cotacaoData.dimens && (this.cotaFrtVolumes.length === 0 || !this.cotaFrtVolumes[0]['comprim'] || this.cotaFrtVolumes[0]['comprim'] === 0)) {
        mensErro.push("O campo comprimento deve ser maior que zero ou preencha o total dimensões (m³), favor corrigir.")
      }
      if (!this.cotacaoData.dimens && (this.cotaFrtVolumes.length === 0 || !this.cotaFrtVolumes[0]['pesocub'] || this.cotaFrtVolumes[0]['pesocub'] === 0)) {
        mensErro.push("O campo peso cubado deve ser maior que zero ou preencha o total dimensões (m³), favor corrigir.")
      }
      if (mensErro.length > 0) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: mensErro,
          showConfirmButton: false,
          timer: 2500
        })
      } else {
        this.updatingCotaInt = true
        this.visibleAc2 = false
        this.visibleAc3 = false
        this.freteCotaCalcsData = null
        this.freteCotaCalcAdicsData = null
        api.post(`${getBaseUrl()}api/cotafrt`, {
          cotafrtData: this.cotacaoData
        }).then((resPost) => {
          console.log('then axios post')
          console.log(resPost)
          api.get(`${getBaseUrl()}api/cotarfrtmanuint`, {
            params: {
              iddata: this.idData
            }
          }).then((res) => {
            console.log('res cotarFrete_00')
            console.log(res.data)
            // console.log(res.data[0]['SDT_WSRetorno'])
            if (res.data[0]['erro']) {
              console.log(res.data[0]['erro'])
              this.errosCotacao = [{
                'Description': res.data[0]['erro']
              }]
            } else {
              this.updatingCotaInt = false
              this.freteCotaCalcsData = res.data[0]
              this.freteCotaCalcAdicsData = res.data[1]
            }
          }).catch((err) => {
            console.log('erro axios')
            console.log(err)
          })
        })
      }
    },


    cotarFreteInternoExterno() {
      console.log('cotarFreteInternoExterno_0')

      let mensErro = []
      if (!this.cotacaoData.dtcoleta) {
        mensErro.push("O campo data de coleta deve ser preenchido, favor corrigir.")
      }
      if (!this.cotacaoData.peso || this.cotacaoData.peso === 0) {
        mensErro.push("O campo peso deve ser maior que zero, favor corrigir.")
      }
      if (!this.cotacaoData.valornf || this.cotacaoData.valornf === 0) {
        mensErro.push("O campo valor nota fiscal deve ser maior que zero, favor corrigir.")
      }
      if (!this.cotacaoData.cnpj || this.cotacaoData.cnpj === '') {
        mensErro.push("O campo CNPJ / CPF do destinatário deve ser preenchido, favor corrigir.")
      }
      if (!this.cotacaoData.cepori || this.cotacaoData.cepori === '') {
        mensErro.push("O campo CEP de origem deve ser preenchido, favor corrigir.")
      }
      if (!this.cotacaoData.cepdest || this.cotacaoData.cepdest === '') {
        mensErro.push("O campo CEP de destino deve ser preenchido, favor corrigir.")
      }
      if (this.cotaFrtVolumes.length === 0 || !this.cotaFrtVolumes[0]['altura'] || this.cotaFrtVolumes[0]['altura'] === 0) {
        mensErro.push("O campo altura deve ser maior que zero, favor corrigir.")
      }
      if (this.cotaFrtVolumes.length === 0 || !this.cotaFrtVolumes[0]['largura'] || this.cotaFrtVolumes[0]['largura'] === 0) {
        mensErro.push("O campo largura deve ser maior que zero, favor corrigir.")
      }
      if (this.cotaFrtVolumes.length === 0 || !this.cotaFrtVolumes[0]['comprim'] || this.cotaFrtVolumes[0]['comprim'] === 0) {
        mensErro.push("O campo comprimento deve ser maior que zero, favor corrigir.")
      }
      if (this.cotaFrtVolumes.length === 0 || !this.cotaFrtVolumes[0]['pesocub'] || this.cotaFrtVolumes[0]['pesocub'] === 0) {
        mensErro.push("O campo peso cubado deve ser maior que zero, favor corrigir.")
      }
      if (mensErro.length > 0) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: mensErro,
          showConfirmButton: false,
          timer: 2500
        })
      } else {
        this.updatingCotaExt = true
        this.updatingCotaInt = true
        this.visibleAc2 = false
        this.visibleAc3 = false
        //this.visibleAc4 = false
        this.freteCotaCalcsData = null
        this.freteCotaCalcAdicsData = null
        this.freteCotaCalcExtsData = null
        api.post(`${getBaseUrl()}api/cotafrt`, {
          cotafrtData: this.cotacaoData
        }).then((resPost) => {
          console.log('then axios post')
          console.log(resPost)
          api.get(`${getBaseUrl()}api/cotarfrtmanuintext`, {
            params: {iddata: this.idData}
          }).then((res) => {
            console.log('res cotarFreteExt_02')
            console.log(res.data)
            // console.log(res.data[0]['SDT_WSRetorno'])
            this.updatingCotaExt = false
            this.updatingCotaInt = false

            this.freteCotaCalcsData = res.data[0][0]
            this.freteCotaCalcAdicsData = res.data[0][1]
            this.freteCotaCalcExtsData = res.data[1][0]

            // this.freteCotaCalcExtsData = res.data[0]
            // this.freteCotaCalcsData = res.data[1]
            // this.freteCotaCalcAdicsData = res.data[2]

          }).catch((err) => {
            console.log('erro axios')
            console.log(err)
          })
        })
      }
    },

    exibirCotacoes(){
      console.log('exibirCotacoes')
      if (!this.cotaFrtResults || this.cotaFrtResults.length === 0) {
        this.cotarFreteEconoPro()
      } else {
        this.showModalCotarFrete = true
      }
    },


    cotarFreteEconoPro() {
      console.log('cotarFreteEconoPro')

      if (this.userPct && this.userPct['consumo'] >= this.userPct['limite']) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Limite de consumo excedido, clique no botão abaixo para upgrade",
          showConfirmButton: true,
        }).then((result) => {
          if (result.value) {
            this.$router.push('/usuario/perfil/' + this.userLogged.id)
          }
        })
      } else {

        this.errosCotacao = null
        this.cotaFrtResults = null
        this.falhasCotacao = []


        let mensErro = []
        if (!this.cotacaoData.peso || this.cotacaoData.peso === 0) {
          mensErro.push("O campo peso deve ser maior que zero, favor corrigir.")
        }
        if (!this.cotacaoData.valornf || this.cotacaoData.valornf === 0) {
          mensErro.push("O campo valor nota fiscal deve ser maior que zero, favor corrigir.")
        }
        if (!this.cotacaoData.cnpj || this.cotacaoData.cnpj === '') {
          mensErro.push("O campo CNPJ / CPF do destinatário deve ser preenchido, favor corrigir.")
        }
        if (!this.cotacaoData.cepori || this.cotacaoData.cepori === '') {
          mensErro.push("O campo CEP de origem deve ser preenchido, favor corrigir.")
        }
        if (!this.cotacaoData.cepdest || this.cotacaoData.cepdest === '') {
          mensErro.push("O campo CEP de destino deve ser preenchido, favor corrigir.")
        }


        if (!this.cotacaoData.dimens && (this.cotaFrtVolumes.length === 0 || !this.cotaFrtVolumes[0]['altura'] || this.cotaFrtVolumes[0]['altura'] === 0)) {
          mensErro.push("O campo altura deve ser maior que zero ou preencha o total dimensões (m³), favor corrigir.")
        }
        if (!this.cotacaoData.dimens && (this.cotaFrtVolumes.length === 0 || !this.cotaFrtVolumes[0]['largura'] || this.cotaFrtVolumes[0]['largura'] === 0)) {
          mensErro.push("O campo largura deve ser maior que zero ou preencha o total dimensões (m³), favor corrigir.")
        }
        if (!this.cotacaoData.dimens && (this.cotaFrtVolumes.length === 0 || !this.cotaFrtVolumes[0]['comprim'] || this.cotaFrtVolumes[0]['comprim'] === 0)) {
          mensErro.push("O campo comprimento deve ser maior que zero ou preencha o total dimensões (m³), favor corrigir.")
        }
        if (!this.cotacaoData.dimens && (this.cotaFrtVolumes.length === 0 || !this.cotaFrtVolumes[0]['pesocub'] || this.cotaFrtVolumes[0]['pesocub'] === 0)) {
          mensErro.push("O campo peso cubado deve ser maior que zero ou preencha o total dimensões (m³), favor corrigir.")
        }
        if (mensErro.length > 0) {
          Swal.fire({
            position: "top-end",
            icon: "warning",
            title: mensErro,
            showConfirmButton: false,
            timer: 2500
          })
        } else {
          this.showModalCotarFrete = true
          this.loadingCotarFrete = true
          this.updatingCotaExt = true
          this.updatingCotaInt = true
          this.visibleAc2 = false
          this.visibleAc3 = false
          //this.visibleAc4 = false
          this.freteCotaCalcsData = null
          this.freteCotaCalcAdicsData = null
          this.freteCotaCalcExtsData = null
          api.post(`${getBaseUrl()}api/cotafrt`, {
            cotafrtData: this.cotacaoData
          }).then((resPost) => {
            console.log('then axios post')
            console.log(resPost)
            api.get(`${getBaseUrl()}api/cotarfrtmanuintext`, {
              params: {iddata: this.idData}
            }).then((res) => {
              console.log('res cotarFreteExt_00')
              console.log(res.data)
              // console.log(res.data[0]['SDT_WSRetorno'])
              this.updatingCotaExt = false
              this.updatingCotaInt = false
              // codigo atual de cotação
              /*this.freteCotaCalcsData = res.data[0][0]
            this.freteCotaCalcAdicsData = res.data[0][1]
            this.freteCotaCalcExtsData = res.data[1][0]*/

              // novo codigo de cotação
              if (res.data[0]) {
                console.log(res.data[0])
                this.cotaFrtResults = res.data[0]
                let menorValor = 999999
                let menorPrazo = 999999
                this.cotaFrtResults.forEach((value) => {
                  if (value.vlrtotalcicms < menorValor) {
                    menorValor = value.vlrtotalcicms
                  }
                  if (value.prazo < menorPrazo) {
                    menorPrazo = value.prazo
                  }

                  value.vlrtotalcicms = parseFloat(value.vlrtotalcicms)

                })

                this.cotaFrtResults.forEach((value) => {
                  if (value.vlrtotalcicms === menorValor) {
                    value['menorvalor'] = true
                  }
                  if (value.prazo === menorPrazo) {
                    value['menorprazo'] = true
                  }
                })

                if (res.data[4]) {
                  this.userPct = res.data[4]
                }

                this.tempoCotacao = res.data[2] + ' ms'
                this.tempoCotacaoExt = res.data[3] + ' ms'

                if (res.data[5] && res.data[5].length > 0) {
                  this.falhasCotacao = res.data[5]
                }

              } else if (res.data[0]['Messages']) {
                console.log('mensagens de erro')
                console.log(res.data[0]['Messages'])
                this.errosCotacao = res.data[0]['Messages']
              }
              this.loadingCotarFrete = false


            }).catch((err) => {
              console.log('erro axios')
              // console.log(err)
              let erros = err.response.data.errors
              console.log(erros)
              console.log(typeof erros)
              let listaErros = []
              Object.keys(erros).forEach(key => {
                console.log(key, erros[key]);
                listaErros.push({
                  'titulo': key,
                  'mensagem': erros[key]
                })
              });
              this.errosCotacao = listaErros
              this.updating = false
            })
          })
        }
      }
    },

    abrirJsonFalha(falha) {
      this.jsonModalData = falha.json
      this.showModalJson = true
    },

    copiarJsonFalha() {
      if (!this.jsonModalData) return
      navigator.clipboard.writeText(JSON.stringify(this.jsonModalData, null, 2)).catch(() => {})
    },

    deletarVol(indexVol) {
      console.log('deletarVol')
      console.log(indexVol)

      this.cotaFrtVolumes.splice(indexVol, 1)

    },


    addVolume() {
      console.log('addVolume')
      this.cotaFrtVolumes.push({
        'cotafrt_id': this.idData
      });


    },


    consultarCNPJ() {
      console.log('consultarCNPJ')

      if(!this.cotacaoData.tipoPessoa || this.cotacaoData.tipoPessoa === 'PJ') {
        console.log('cliente PJ')
        const cnpjTratado = this.cotacaoData.cnpj.replaceAll('.', '').replaceAll('/', '').replaceAll('-', '')
        this.identClient = cnpjTratado;
        console.log(this.identClient)
        if (cnpjTratado.length !== 14) {
          this.verificaCliente = false;
          this.msgErro = "O campo CNPJ deve possuir no mínimo 14 caracteres, favor corrigir.";
        }
      } else if (this.cotacaoData.tipoPessoa === 'PF') {
        console.log('cliente PF')
        const cpfTratado = this.cotacaoData.cnpj.replaceAll('.','').replaceAll('-','')
        this.identClient = cpfTratado;
        console.log(this.identClient)
        if(cpfTratado.length !== 11){
          this.verificaCliente = false;
          this.msgErro = "O campo CPF deve possuir no mínimo 11 caracteres, favor corrigir.";
        }
      }

      if (this.verificaCliente === false) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: this.msgErro,
          showConfirmButton: false,
          timer: 1500
        })
      } else {
        console.log(this.identClient)
        console.log(this.identClient.length)
        this.loadingCnpj = true

        api.get(`${getBaseUrl()}api/conscnpj`, {
          params: {cnpj: this.identClient }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)

          if(res.data[0] === "ERROR"){
            Swal.fire({
              position: "top-end",
              icon: "error",
              title: res.data[1],
              showConfirmButton: false,
              timer: 1500
            })
          } else {
            const dadosCnpj = res.data[0]
            this.cotacaoData.nome = dadosCnpj.nome
            this.cotacaoData.logrdest = dadosCnpj.logradouro
            this.cotacaoData.compldest = dadosCnpj.compl
            this.cotacaoData.bairrodest = dadosCnpj.bairro
            this.cotacaoData.ciddest = dadosCnpj.municipio
            this.cotacaoData.ufdest = dadosCnpj.uf
            this.cotacaoData.cepdest = dadosCnpj.cep
            if (!this.cotacaoData.nrodest_manual) {
              this.cotacaoData.nrodest = dadosCnpj.numero
            }
            this.snapshotCamposCalculo()

            // O endereço da Receita pode divergir do endereço oficial dos Correios
            // para o mesmo CEP. Revalida via ViaCEP e sobrescreve logradouro/bairro/
            // cidade/UF, mantendo o número já obtido da Receita (ViaCEP não retorna número).
            this.informouCepDest()
          }

          this.loadingCnpj = false
        });
      }
    },

    informouCepOri() {
      console.log('informouCepOri')
      const cepTratado = this.cotacaoData.cepori.replaceAll('.', '').replaceAll('-', '')
      if (cepTratado.length === 8) {
        this.loadingCidOri = true
        api.get(`${getBaseUrl()}api/conscep`, {
          params: {cep: cepTratado}
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          const dataCep = res.data[0]
          this.cotacaoData.cidori = dataCep.localidade
          this.cotacaoData.bairroori = dataCep.bairro
          this.cotacaoData.logrori = dataCep.logradouro
          this.cotacaoData.complori = dataCep.complemento
          this.cotacaoData.ufori = dataCep.uf
          //this.cotacaoData.nroori = this.nroOrigem === null ? "SN" : this.nroOrigem

          this.snapshotCamposCalculo()
          this.loadingCidOri = false
        });
      }
    },

    // Cotações vindas de fretecotaapi podem ter herdado o endereço do cadastro
    // Pessoa do destinatário (de outra entrega/unidade), divergindo do CEP de
    // destino real da cotação. Revalida via ViaCEP ao abrir a tela, sem alterar
    // a rota de cotação em si.
    recalcularEnderecoDestApi() {
      if (this.cotacaoData.tipo !== 'manual' && this.cotacaoData.cepdest) {
        this.informouCepDest()
      }
    },

    informouCepDest() {
      console.log('informouCepDest')
      const cepTratado = this.cotacaoData.cepdest.replaceAll('.', '').replaceAll('-', '')
      if (cepTratado.length === 8) {
        this.loadingCidDest = true
        api.get(`${getBaseUrl()}api/conscep`, {
          params: {cep: cepTratado}
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          if (res.data[0] === 'erro') {
            Swal.fire({
              position: "top-end",
              icon: "warning",
              title: "Erro: " + res.data[1],
              showConfirmButton: false,
              timer: 3500
            })
            /*this.cotacaoData.ciddest = null
            this.cotacaoData.bairrodest = null
            this.cotacaoData.logrdest = null
            this.cotacaoData.compldest = null
            this.cotacaoData.ufdest = null
            this.cepinvalido = res.data[0]*/
          } else {
            const dataCep = res.data[0]
            this.cotacaoData.ciddest = dataCep.localidade
            this.cotacaoData.bairrodest = dataCep.bairro
            this.cotacaoData.logrdest = dataCep.logradouro
            this.cotacaoData.compldest = dataCep.complemento
            this.cotacaoData.ufdest = dataCep.uf
            //this.cotacaoData.nrodest = this.nroDestino === null ? "SN" : this.nroDestino
          }
          this.snapshotCamposCalculo()
          this.loadingCidDest = false
        });
      }
    },

    // pesqSegto(evt) {
    //   console.log('pesqSegto')
    //   console.log(evt)
    //   let query = evt
    //   if (query.length > 1){
    //     api.get(`${getBaseUrl()}api/segtopesq`, {
    //       params: { q: query, c: 'FO' }
    //     }).then((res) => {
    //       console.log('then axios')
    //       console.log(res.data)
    //       this.dtListPesqSegto = res.data
    //     });
    //   }
    //
    // },

    pesqFreteCotaEmpr(evt) {
      console.log('pesqFreteCotaEmpr')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1) {
        // this.loadingTransp = true

        api.get(`${getBaseUrl()}api/pesqfretecotaempr`, {
          params: {q: query, e: this.cotacaoData.empresa}
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqSegto = res.data
        })
      }
    },


    escolheuSegto() {
      console.log('escolheuSegto')

    },


    editar(dataReg) {
      console.log('editar')
      this.cotaFrtVolume = dataReg
      this.showModalVolume = true
    },

    deletar(dataID) {
      console.log('deletar: ' + dataID)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {
          console.log('deletouReg_pai dataid:')
          console.log(dataID)

          this.loadingList = true
          api.delete(`${getBaseUrl()}api/cotafrtvol`, {
            params: {
              'iddata': dataID
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            this.carregarDados()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
          })
        }
      })
    },

    novoVolume() {
      console.log('novoVolume')
      this.cotaFrtVolume = {}

      this.submittedVolume = false
      this.showModalVolume = true

      // this.cotaFrtVolumes.push({
      //   'cotafrt_id': this.idData
      // });
    },

    deletarEquipe(dataID) {
      console.log('deletarEquipe')

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/projequip`, {
            params: {
              'iddata': dataID
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            this.carregarDados()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
          })

        }
      })
    },


    confVolume() {
      console.log('confVolume')
      console.log(this.cotaFrtVolumes)
      this.submittedVolume = true

      let todosVolValids = true

      this.cotaFrtVolumes.forEach((value) => {
        if (!value.largura > 0 || !value.altura > 0 || !value.comprim > 0 || !value.quant > 0) {
          todosVolValids = false
        }
      })

      if (todosVolValids) {

        console.log('formSubmit_volume_validado')
        this.showModalVolume = false
        this.cotaFrtVolume.cotafrt_id = this.idData

        this.updating = true
        this.errosValid = []
        api.post(`${getBaseUrl()}api/cotafrtvols`, {
          cotafrtvolsData: this.cotaFrtVolumes,
          idcotafrt: this.idData
        }).then((res) => {
          console.log('then axios')
          console.log(res)

          this.updating = false

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })

          this.carregarDados()

        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false

        })

      }
    },


    copiarCotacao() {
      console.log('copiarCotacao')
      this.updating = true
      api.post(`${getBaseUrl()}api/cotafrtcopy`, {
        iddata: this.idData
      }).then((res) => {
        console.log('then axios')
        console.log(res)
        this.cotacaoData.status = 'AB'
        this.updating = false
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Cotação copiada com sucesso",
          showConfirmButton: false,
          timer: 1500
        }).then(() => {

          this.idData = res.data[0].id
          this.$router.replace({path: `/cotafrt/editar/${this.idData}`})
          this.carregarDados()
        })


      })

    },


    cancelarCota() {
      console.log('cancelarCota')

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Cancelamento de Cotação",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {

          this.updating = false

          api.post(`${getBaseUrl()}api/cotafrtcanc`, {
            iddata: this.idData
          }).then((res) => {
            console.log('then axios')
            console.log(res)

            this.cotacaoData.status = 'CA'

            this.updating = false
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Cotação cancelada com sucesso",
              showConfirmButton: false,
              timer: 1500
            })
          })
        }
      })
    },

    imprimirCotacao() {
      console.log('imprimirCotacao')
      api.get(`${getBaseUrl()}api/cotafrimpr`, {
        params: {iddata: this.idData}
      }).then((res) => {
        console.log('then axios imprcota')
        // console.log(res.data)
        const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')
        WinPrint.document.write(res.data[0])
        WinPrint.document.close()
        WinPrint.focus()
        WinPrint.print()
        WinPrint.close()
      });
    },

    imprimirCotacaoProgramada() {
      console.log('imprimirCotacaoProgramada')
      api.get(`${getBaseUrl()}api/cotafrimprprog`, {
        params: {iddata: this.idData}
      }).then((res) => {
        console.log('then axios imprcota')
        // console.log(res.data)
        const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')
        WinPrint.document.write(res.data[0])
        WinPrint.document.close()
        WinPrint.focus()
        WinPrint.print()
        WinPrint.close()
      });
    },


    carregarDados() {

      this.updating = true

      api.get(`${getBaseUrl()}api/cotafrt`, {
        params: {iddata: this.idData}
      }).then((res) => {
        console.log('then axios cotafrt')
        console.log(res.data)
        this.cotacaoData = res.data[0]
        this.cotaFrtVolumes = res.data[1]
        this.qtdVols = this.cotaFrtVolumes.length
        console.log(`qtdVols: ${JSON.stringify(this.qtdVols)}`)
        this.seguimentoData = res.data[2]
        this.freteCotaCalcsData = res.data[3]
        this.freteCotaCalcExtsData = res.data[4]
        this.correiosServData = res.data[5]
        this.freteCotaCalcAdicsData = res.data[6]
        this.emprOrigensData = res.data[7]
        this.cotacaoDataSelected = res.data[8]
        this.userPct = res.data[9]


        if (this.seguimentoData && this.seguimentoData.id) {
          this.dtListPesqSegto = [
            {
              'codigo': this.seguimentoData.codigo,
              'nome': this.seguimentoData.nome,
            }
          ]
        }

        if (this.correiosServData && this.correiosServData.id) {
          this.dtListPesqCorreioServico = [
            {
              'codigo': this.correiosServData.codigo,
              'descricao': this.correiosServData.descricao,
            }
          ]
        }

        this.totalAlt = 0.00
        this.totalComp = 0.00
        this.totalLarg = 0.00
        this.totalQuant = 0.00
        this.totalMCub = 0.00

        if (this.cotaFrtVolumes.length > 0) {
          this.cotaFrtVolumes.forEach((volume) => {
            // console.log('volume')
            // console.log(volume.altura)
            // console.log(this.totalAlt)
            this.totalAlt += parseFloat(volume.altura)
            this.totalComp += parseFloat(volume.comprim)
            this.totalLarg += parseFloat(volume.largura)
            this.totalQuant += parseFloat(volume.quant)
            this.totalMCub += parseFloat(volume.pesocub)
          })
          this.cotacaoData.altura = this.totalAlt
          this.cotacaoData.largura = this.totalLarg
          this.cotacaoData.comprim = this.totalComp
        }

        if(this.cotacaoData && this.cotacaoData.cnpj){
          this.cotacaoData.tipoPessoa = this.cotacaoData.cnpj.length === 14 ? 'PJ' : 'PF';
        }


        // A lista é remontada a cada carga: sem o reset, os cálculos da cotação
        // anterior (ex.: após copiar a cotação) permaneceriam na relação.
        this.cotacaoIntExtApi = []

        this.freteCotaCalcsData.forEach((value) => {
          this.cotacaoIntExtApi.push({
            id: value.id,
            codigo: value.codigo,
            status: value.status,
            vlrtotalcicms: value.vlrtotalcicms,
            percdesc: value.percdesc,
            valdesc: value.valdesc,
            // De qual Regra de Desconto veio o abatimento desta linha; sem copiar
            // aqui, a relação recarregada perde a trilha (chamado 2150).
            regrasobs: value.regrasobs,
            freteperc: value.freteperc,
            fretekg: value.fretekg,
            pesoinf: value.pesoinf,
            pesocubtotal: value.pesocubtotal,
            pesobscalc: value.pesobscalc,
            prazo: value.prazo,
            transpnome: value.transpnome,
            transpcnpj: value.transpcnpj,
            regraret: value.regraret,
          })
        })

        this.freteCotaCalcExtsData.forEach((value) => {
          this.cotacaoIntExtApi.push({
            id: value.id,
            // Número da cotação devolvido pela transportadora na API: sem ele a
            // relação recarregada perde a identificação do lado da transportadora.
            codigo: value.codigo,
            status: value.status,
            // Termo/observação da cotação externa (ex.: quantidade de volumes
            // estimada nos Correios, chamado 2166).
            obs: value.obs,
            vlrtotalcicms: value.fretetotal,
            percdesc: value.percdesc,
            valdesc: value.valdesc,
            freteperc: value.freteperc,
            fretekg: value.fretekg,
            pesoinf: value.peso,
            pesocubtotal: value.pesocubtotal,
            pesobscalc: value.pesobscalc,
            prazo: value.prazo,
            transpnome: value.transpnome,
            transpcnpj: value.transpcnpj,
            regraret: value.regraret,
          })
        })

        // Mesma ordenação que o endpoint de cotação ao vivo aplica, para a
        // relação recarregada não trocar a ordem das linhas.
        this.cotacaoIntExtApi.sort(
            (a, b) => parseFloat(a.vlrtotalcicms) - parseFloat(b.vlrtotalcicms)
        )

        if(this.cotacaoIntExtApi && this.cotacaoData.tipo !== 'manual') {
          let menorValor = 999999
          let menorPrazo = 999999
          this.cotacaoIntExtApi.forEach((value) => {
            if (value.vlrtotalcicms < menorValor) {
              menorValor = value.vlrtotalcicms
            }
            if (value.prazo < menorPrazo) {
              menorPrazo = value.prazo
            }

            value.vlrtotalcicms = parseFloat(value.vlrtotalcicms)

          })

          this.cotacaoIntExtApi.forEach((value) => {
            if (value.vlrtotalcicms === menorValor) {
              value['menorvalor'] = true
            }
            if (value.prazo === menorPrazo) {
              value['menorprazo'] = true
            }
          })
        }

        // A relação exibida em "Exibir Cotações" vinha só de res.data[3] (cálculos
        // internos): ao recarregar, as opções devolvidas via API sumiam da tela,
        // junto com o número de cotação da transportadora. Usa a mesma lista
        // int+ext que a cotação ao vivo monta.
        this.cotaFrtResults = this.cotacaoIntExtApi

        this.limparEscolhaTranspOrfa()

        this.idData = this.cotacaoData.id
        this.title = `Cotar Frete (${this.cotacaoData.id}) ${this.cotacaoData.cidori} - ${this.cotacaoData.ciddest} (${this.cotacaoData.tipo})`

        this.recalcularEnderecoDestApi()

        this.snapshotCamposCalculo()

        this.updating = false
      });
    },


    formSubmit() {
      console.log('formSubmit')
      console.log(this.userPct)
      console.log(this.empresaData)
      this.submitted = true;
      if (this.userPct && !this.empresaData.id){
        Swal.fire({
          position: 'center',
          icon: 'warning',
          title: 'Pendência de Configuração!',
          text: 'Empresa não definida para usuário atual, favor entrar no seu perfil e definir as informações da empresa.',
          showCancelButton: true,
          showConfirmButton: true,
          confirmButtonText: 'Acessar Perfil',
          cancelButtonText: 'Fechar'
        }).then((selected) => {
          if (selected.isConfirmed) {
            const routeData = this.$router.resolve('/usuario/perfil/' + this.userLogged.id)
            window.open(routeData.href)
          }
        })
      } else {

        if (this.cotacaoData.cepori && this.cotacaoData.cepdest && this.cotacaoData.cidori && this.cotacaoData.ciddest) {

          this.updating = true
          this.errosValid = []

          api.post(`${getBaseUrl()}api/cotafrt`, {
            cotafrtData: this.cotacaoData

          }).then((res) => {
            console.log('then axios')
            console.log(res)

            this.updating = false

            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações salvas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })

            if (this.idData === 0) {
              this.idData = res.data[0].id
              this.cotacaoData = res.data[0]

              this.title = `Cotar Frete (${this.cotacaoData.id}) ${this.cotacaoData.cidori} - ${this.cotacaoData.ciddest}`

              this.$router.replace('/cotafrt/editar/' + this.idData)
            }

          }).catch((err) => {
            console.log('erro axios')
            // console.log(err)
            // console.log(err.response)
            // console.log(err.response.data.errors)
            let erros = err.response.data.errors
            console.log(erros)
            console.log(typeof erros)
            let listaErros = []
            Object.keys(erros).forEach(key => {
              console.log(key, erros[key]);
              listaErros.push({
                'titulo': key,
                'mensagem': erros[key]
              })
            });
            this.errosValid = listaErros
            this.updating = false
            this.activeTab = 0
          })
        }
      }
    },


    formatDate(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return "0,00";
    },

    formatDecimalDois(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2,maximumFractionDigits: 2});
      }
      return "0,00";
    },



    formatDecimalQuatro(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 4, maximumFractionDigits: 4});
      }
      return "0,00";
    },

  },

  created() {

    this.userLogged = JSON.parse(localStorage.getItem('user'))

  },


  mounted() {
    console.log('mounted_cotafrete_editar_000')
    let rota = this.$route.path
    // console.log(rota)
    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra) {
      this.idData = parseInt(rota.substring(ultimaBarra + 1))
    }

    if (window.location.href.includes('localhost')
        || window.location.href.includes('lelloprint')
        || window.location.href.includes('bluevix')) {
      this.dominioMigrouCalc = true
    }


    console.log(`idData: ${this.idData}`)
    if (this.idData > 0) {

      this.carregarDados()

    } else {

      this.title = `Criando Nova Cotação`
      this.updating = true

      api.get(`${getBaseUrl()}api/novacota`).then((res) => {
        console.log('then axios novacota')
        console.log(res.data)
        if (res.data[0] !== 'nenhum seguimento para a empresa do usuário'){
          this.seguimentoData = res.data[0]
          if (this.seguimentoData && this.seguimentoData.id) {
            this.cotacaoData.segto = this.seguimentoData.codigo
            this.dtListPesqSegto = [
              {
                'codigo': this.seguimentoData.codigo,
                'nome': this.seguimentoData.nome,
              }
            ]
          }
          this.empresaData = res.data[1]
          this.dtListPesqEmpresa.push({
            cidade: this.empresaData.cidade,
            cnpj: this.empresaData.cnpj,
            codigo: this.empresaData.codigo,
            created_at: this.empresaData.created_at,
            id: this.empresaData.id,
            nome: this.empresaData.nome,
            status: this.empresaData.status,
          })
          this.cotacaoData.empresa = this.empresaData.codigo
          this.cotacaoData.cepori = this.empresaData.cep
          this.cotacaoData.cidori = this.empresaData.cidade
          this.cotacaoData.nroori = this.empresaData.numero
          this.cotacaoData.logrori = this.empresaData.rua
          this.cotacaoData.complori = this.empresaData.compl
          this.cotacaoData.bairroori = this.empresaData.bairro
          this.cotacaoData.ufori = this.empresaData.estado
          if (res.data[2] && res.data[2] !== '') {
            this.cotacaoData.codserv = res.data[2].codigo
            this.dtListPesqCorreioServico = [
              {
                'codigo': res.data[2].codigo,
                'descricao': res.data[2].descricao,
              }
            ]
          }
          this.userPct = res.data[3]

        } else {
          this.userPct = res.data[1]
          if (res.data[2]){
            this.empresaData = res.data[2]
          }
        }
        this.snapshotCamposCalculo()
        this.updating = false
      });
    }
  },

  watch: {
    'cotacaoData.valorbrt': {
      handler() {
        this.calculaTotal()
      }
    },
    'cotacaoData.desconto': {
      handler() {
        this.calculaTotal()
      }
    },
  },

};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" :status="cotacaoData.status"/>

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <b-alert show dismissible
             v-if="userPct && userPct.id > 0 && !updating"
             :variant="userPct.limite - userPct.consumo <= 10 ? 'danger' : userPct.limite - userPct.consumo <= 50 ? 'warning' : 'info'">
      <a class="dropdown-item "
         @click="upgradePlano"
         href="javascript: void(0);">
        <i class="mdi mdi-alert me-2"></i>Plano atual consumindo {{ userPct.consumo }} unidade(s) das {{ userPct.limite }} contratada(s), <span class="text-warning">clique aqui e faça upgrade agora mesmo.<i class="mdi mdi-rocket-launch ms-2"></i> </span>
      </a>
    </b-alert>

    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`" show dismissible variant="danger">
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>

    <b-alert v-if="camposBloqueados && !updating" show variant="info">
      <i class="mdi mdi-lock me-2"></i>
      <span v-if="transpEscolhida">Transportadora já escolhida para esta cotação, os campos estão somente para
        consulta e não podem ser alterados.</span>
      <span v-else>Cotação não está em aberto, os campos estão somente para consulta e não podem ser
        alterados.</span>
      Apenas a data de coleta e a observação de coleta continuam liberadas para alteração.
    </b-alert>

    <div class="checkout-tabs" v-if="!updating">

      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-start">
              <!-- Continua habilitado mesmo com a cotação bloqueada: os campos de
                   coleta (data e observação) podem ser alterados a qualquer momento. -->
              <b-button variant="outline-success" class="mx-2" @click="formSubmit"
                        id="btnSalvar"
                        v-if="cotacaoData.tipo === 'manual'">
                <i class="bx bx-save font-size-16 align-middle me-2"></i>
                Salvar
              </b-button>


              <b-button variant="outline-danger" class="mx-2" @click="cancelarCota"
                        v-if="cotacaoData.tipo === 'manual'"
                        :disabled="cotacaoData.id === 0 || cotacaoData.status === 'CA'">
                <i class="bx bx-block font-size-16 align-middle me-2"></i>
                Cancelar
              </b-button>



              <b-button variant="outline-info" class="mx-2" @click="exibirCotacoes"
                        v-if="cotacaoData.id > '0' && cotacaoData.status === 'AB' && cotacaoData.tipo === 'manual'">
                <i class="bx bxs-truck font-size-16 align-middle me-2"></i>
                {{ !this.cotaFrtResults || this.cotaFrtResults.length === 0 ? 'Cotar Frete' : 'Exibir Cotações' }}
              </b-button>

              <b-button variant="outline-info" class="mx-2" @click="showModalCotacaoApi = true"
                        v-if="cotacaoData.id > '0' && cotacaoData.status === 'AB' && cotacaoData.tipo !== 'manual'">
                <i class="bx bxs-truck font-size-16 align-middle me-2"></i>
                Cotações
              </b-button>


              <b-button variant="warning" class="mx-2" @click="novoVolume"
                        v-if="cotacaoData && cotacaoData.status === 'AB' && cotacaoData.id > 0 && cotacaoData.tipo === 'manual'">
                <i class="bx bx-box font-size-16 align-middle me-2"></i>
                Volumes da Cotação
              </b-button>

              <b-button variant="info" class="mx-2" @click="showModalOrigem = true"
                        v-if="cotacaoData && cotacaoData.status === 'AB' && cotacaoData.id > 0 && cotacaoData.tipo === 'manual' && !transpEscolhida">
                <i class="bx bx-buildings font-size-16 align-middle me-2"></i>
                Alterar Origem
              </b-button>


              <b-button variant="secondary" class="mx-2" @click="executarComCalculo(alteraTipoFrete)"
                        v-if="cotacaoData && cotacaoData.status === 'AB' && cotacaoData.id > 0 && cotacaoData.tipo === 'manual' && !transpEscolhida">
                <i class="bx bx-sync font-size-16 align-middle me-2"></i>
                {{ tipoFrete }}
              </b-button>

              <b-button variant="info" class="mx-2" @click="enviaCotacao"
                        v-if="cotacaoData.id > '0' && cotacaoData.status === 'AB'
                        && !updatingCotaInt && !updatingCotaExt
                        && cotacaoData.id > 0 && cotacaoData.nometransp !== ''
                        && (freteCotaCalcsData === null || freteCotaCalcsData.length === 0)
                        && (freteCotaCalcExtsData === null || freteCotaCalcExtsData.length === 0)">
                <i class="bx bx-mail-send font-size-16 align-middle me-2"></i>
                Contratar
              </b-button>

              <b-button variant="outline-warning" class="mx-2" @click="cotacaoDemanda"
                        v-if="cotacaoData.id > '0' && cotacaoData.status === 'AB'
                        && !updatingCotaInt && !updatingCotaExt
                        && cotacaoData.id > 0">
                <i class="bx bx-send font-size-16 align-middle me-2"></i>
                Demanda
              </b-button>

              <b-button variant="info" class="mx-2" @click="ajuda">
                <i class="bx bx-help-circle font-size-16 align-middle me-2"></i>
                Ajuda
              </b-button>



<!--              <DxItem-->
<!--                  location="before"-->
<!--                  widget="dxButton">-->
<!--                <DxButton-->
<!--                    icon="help"-->
<!--                    text="Ajuda"-->
<!--                    type="normal"-->
<!--                    :on-click="ajuda"/>-->
<!--              </DxItem>-->



              <!-- MOTIVO DE CODIGO ABAIXO SER COMENTADO: Em chamado id:651, foi solicitado a desativação total da cotação no econofrete, sendo feita apenas agora
                            via econopro e no escopo foi solicitado que não era para ter a separação entre interno e externo cotando ambos de uma única vez. -->

<!--              <b-dropdown
                  v-if="cotacaoData.id > '0' && cotacaoData.status === 'AB' && cotacaoData.tipo === 'manual'"
                  ngbDropdown
                  menu-class="dropdown-menu-md dropdown-menu-end mx-2"
                  right
                  variant="light">
                <template v-slot:button-content>
                  <i class="mdi mdi-layers-search me-1"></i>
                  <span class="d-none d-sm-inline-block" ngbDropdownToggle>
                      Cotação
                      <i class="mdi mdi-chevron-down"></i>
                    </span>
                </template>


                <div>
                  <a class="dropdown-item text-primary text-center"
                     @click="cotarFreteInterno"
                     href="javascript: void(0);">
                    Cotar Frete Interno
                  </a>
                  <b-dropdown-divider></b-dropdown-divider>
                  <a class="dropdown-item text-primary text-center"
                     @click="cotarFreteExterno"
                     href="javascript: void(0);">
                    Cotar Frete Externo
                  </a>
                  <b-dropdown-divider></b-dropdown-divider>
                  <a class="dropdown-item text-primary text-center"
                     @click="cotarFreteInternoExterno"
                     href="javascript: void(0);">
                    Cotar Frete Interno e Externo
                  </a>

                </div>

              </b-dropdown>-->



              <!--              <div class="ms-auto">-->
              <!--                <b-button :disabled="cotacaoData.id === 0" variant="outline-dark" class="mx-2" @click="imprimirCotacaoProgramada">-->
              <!--                  <i class="bx bx-printer font-size-16 align-middle me-2"></i>-->
              <!--                  Imprimir (Programada)-->
              <!--                </b-button>-->
              <!--              </div>-->

              <div class="ms-auto">
                <b-button :disabled="cotacaoData.id === 0" variant="outline-secondary" class="mx-2" @click="copiarCotacao">
                  <i class="bx bx-copy font-size-16 align-middle me-2"></i>
                  Copiar
                </b-button>


                <b-button :disabled="cotacaoData.id === 0" variant="outline-dark" class="mx-2" @click="imprimirCotacao">
                  <i class="bx bx-printer font-size-16 align-middle me-2"></i>
                  Imprimir
                </b-button>
              </div>

            </div>
          </div>
        </div>
      </div>


      <form class="needs-validation" @submit.prevent="formSubmit">


        <div class="card" v-if="cotacaoData.cotaid > 0">
          <div class="card-body">
            <b-card-body>

              <div class="d-flex justify-content-between" v-if="cotacaoDataSelected[0]">
                <h5 class="mb-4"> Informações Cotação - ID: {{ cotacaoDataSelected[0].id ?? cotacaoData.cotaid }}
                  <span v-if="cotacaoDataSelected[0].codigo"> - Nº Cotação Transportadora: {{ cotacaoDataSelected[0].codigo }}</span>
                </h5>

                <b-button v-if="cotacaoDataSelected[0] && cotacaoDataSelected[0].status === 'AB' && cotacaoData.status === 'AB'" class="d-flex    mb-4" variant="warning" @click="contratar(cotacaoData.cotaid ?? cotacaoDataSelected[0].id)">
                  Contratar Frete <i class="bx bx-mail-send font-size-18" style="margin-left: 5px"></i>
                </b-button>
              </div>


              <div class="row mb-2">

                <div class="col-md-3">
                  <label for="nometransp">Transportadora</label>
                  <div class="position-relative">
                    <input id="nometransp" type="text" v-model="cotacaoData.nometransp" class="form-control"
                           :disabled="true" placeholder="Transportadora"/>
                  </div>
                </div>

                <div class="col-md-3">
                  <label for="cnpjtransp">CNPJ Transportadora</label>
                  <div class="position-relative">
                    <input id="cnpjtransp" type="text" v-model="cotacaoData.cnpjtransp" class="form-control"
                           :disabled="true" placeholder="CNPJ"/>
                  </div>
                </div>

                <div class="col-md-2 text-end">
                  <label for="valorfrete">Valor Frete</label>
                  <div class="position-relative">
                    <input id="valorfrete" type="number" v-model="cotacaoData.valorfrete"
                           class="form-control text-end" :disabled="true" placeholder="Valor Frete"/>
                  </div>
                </div>

                <div class="col-md-2 text-end">
                  <label for="pesofrete">Peso Frete</label>
                  <div class="position-relative">
                    <input id="pesofrete" type="number" v-model="cotacaoData.pesofrete" class="form-control text-end"
                           :disabled="true" placeholder="Peso Frete"/>
                  </div>
                </div>

                <div class="col-md-2 text-end">
                  <label for="prazo">Prazo</label>
                  <div class="position-relative">
                    <input id="prazo" type="number" v-model="cotacaoData.prazo" class="form-control text-end"
                           :disabled="true" placeholder="Prazo"/>
                  </div>
                </div>


              </div>


            </b-card-body>
          </div>
        </div>


        <div class="card">
          <div class="card-body">
            <div v-if="qtdVols === 0">
              <b-alert variant="warning" show>
                Para obter retorno do serviços Correios(Sedex, Pac, outros), é obrigatório informar as dimensões de cada volume e realizar o agendamento da data de coleta
              </b-alert>
            </div>

            <b-card-body id="bCardOriDest">

              <h5 class="mb-4"> Origem e Destino </h5>

              <div class="flex-grow-1 align-self-center">
                <h6>Empresa</h6>
                <div class="col-md-4 mb-2" v-if="idData === 0">
                  <multiselect id="empresaProd"
                               @search-change="pesqEmpresa"
                               @change="escolheuEmpresa"
                               v-model="cotacaoData.empresa"
                               placeholder="Selecionar Empresa"
                               :options="dtListPesqEmpresa"
                               :searchable="true"
                               :disabled="camposBloqueados"
                               track-by="codigo"
                               label="nome"
                               value-prop="codigo">
                    <template #option="slotProps">
                      <div class="row">
                        <div>
                  <span class="text-info">
                    {{ slotProps.option.cnpj }}
                  </span>
                          <span class="mx-4" >
                  </span>
                        </div>
                        <div class="mt-2 font-size-20">{{ slotProps.option.nome }}</div>
                        <span class="mx-4">
                </span>
                        <span class="mx-4" >
                </span>
                        <div class="align-items-end text-end align-content-end">Código: {{ slotProps.option.codigo }} </div>
                      </div>
                    </template>
                  </multiselect>
                </div>
              </div>

              <div class="row mb-2">
                <div class="col-md-6">
                  <label for="cidade">Segmento</label>
                  <multiselect @search-change="pesqFreteCotaEmpr" @select="escolheuSegto"
                               @change="alterouCampoCotacao('segto')"
                               v-model="cotacaoData.segto" placeholder="Pesquisar seguimento" :options="dtListPesqSegto"
                               :searchable="true" label="nome" track-by="nome"
                               :disabled="camposBloqueados || (userLogged && userLogged.tipo !== 'admin')"
                               value-prop="codigo">
                    <template #option="slotProps">
                      <div class="row">
                        <div>
                          <span class="text-info">
                            {{ slotProps.option.codigo }}
                          </span>

                        </div>
                        <div class="mt-2 font-size-20">{{ slotProps.option.nome }}</div>
                      </div>
                    </template>
                  </multiselect>

                </div>

                <div class="col-md-3">

                  <div class="d-flex">
                    <label for="cnpj">Destinatário (CNPJ / CPF)</label>

                    <div class="col-sm-3" style="position: relative; left: 2ch">
                      <div class="" style="width: 150px">
                        <div class="d-flex align-items-center justify-content-between" style="margin-top: 0px">
                          <b-form-checkbox
                              id="tipo"
                              switch
                              size="md"
                              value="PF"
                              unchecked-value="PJ"
                              :disabled="camposBloqueados"
                              v-model="cotacaoData.tipoPessoa">
                            {{ cotacaoData.tipoPessoa === 'PF' ? 'Pessoa Física' : 'Pessoa Jurídica' }}
                          </b-form-checkbox>
                        </div>
                      </div>
                    </div>

                  </div>

                  <div class="position-relative">
                    <input id="cnpj" v-maska="maskCnpjCpf" type="text" v-model="cotacaoData.cnpj" class="form-control"
                           @change="alterouCampoCotacao('cnpj')"
                           placeholder="CNPJ / CPF" :disabled="camposBloqueados" />

                    <div class="chat-input-links" v-if="cotacaoData.cnpj && !camposBloqueados">
                      <ul class="list-inline mb-0">
                        <li class="list-inline-item">
                          <a @click="executarComCalculo(consultarCNPJ)" href="javascript: void(0);" v-b-tooltip.hover placement="top"
                             title="Consultar CNPJ">
                            <i class="mdi mdi-cloud-search-outline"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="col-md-3">
                  <label for="nome">Nome destinatário</label>
                  <div v-if="!loadingCnpj" class="position-relative">
                    <input id="nome" type="text" v-model="cotacaoData.nome" class="form-control"
                           placeholder="Nome destinatário" :disabled="camposBloqueados"/>
                  </div>
                  <Loader v-if="loadingCnpj" style="min-height: 50px;">
                  </Loader>
                </div>
              </div>

              <div class="row mb-2">
                <div class="col-md-3">
                  <label for="cepori">CEP Origem</label>
                  <div class="position-relative">
                    <input id="cepori" type="text" v-maska="'##.###-###'" v-model="cotacaoData.cepori"
                           class="form-control" @change="alterouCampoCotacao('cepori', informouCepOri)"
                           :disabled="camposBloqueados"
                           :class="{ 'is-invalid': submitted && !cotacaoData.cepori }" placeholder="CEP Origem"/>
                    <div v-if="submitted && !cotacaoData.cepori" class="invalid-feedback">
                      <span>Campo CEP origem obrigatório, favor preencher.</span>
                    </div>
                  </div>
                </div>

                <div class="col-md-3">
                  <label for="cidori">Cidade Origem</label>
                  <div v-if="!loadingCidOri" class="position-relative">
                    <input id="cidori" type="text" v-model="cotacaoData.cidori"
                           @change="alterouCampoCotacao('cidori')"
                           :class="{ 'is-invalid': submitted && !cotacaoData.cidori }" class="form-control"
                           placeholder="Cidade Origem" :disabled="camposBloqueados"/>

                    <div v-if="submitted && !cotacaoData.cidori" class="invalid-feedback">
                      <span>Campo cidade origem obrigatório, favor preencher.</span>
                    </div>
                  </div>

                  <Loader v-if="loadingCidOri" style="min-height: 50px;">
                  </Loader>
                </div>


                <div class="col-md-3">
                  <label for="cepdest">CEP Destino</label>
                  <div v-if="!loadingCidDest && !loadingCnpj" class="position-relative">
                    <input id="cepdest" type="text" v-maska="'##.###-###'" v-model="cotacaoData.cepdest"
                           class="form-control" @change="alterouCampoCotacao('cepdest', informouCepDest)"
                           :disabled="camposBloqueados"
                           :class="{ 'is-invalid': submitted && !cotacaoData.cepdest }" placeholder="CEP Destino"/>
                    <div v-if="submitted && !cotacaoData.cepdest" class="invalid-feedback">
                      <span>Campo CEP destino obrigatório, favor preencher.</span>
                    </div>
                  </div>
                  <Loader v-if="loadingCnpj" style="min-height: 50px;">
                  </Loader>
                </div>

                <div class="col-md-3">
                  <label for="ciddest">Cidade Destino</label>
                  <div v-if="!loadingCidDest && !loadingCnpj" class="position-relative">
                    <input id="ciddest" type="text" v-model="cotacaoData.ciddest"
                           @change="alterouCampoCotacao('ciddest')"
                           :class="{ 'is-invalid': submitted && !cotacaoData.ciddest }" class="form-control"
                           placeholder="Cidade Destino" :disabled="camposBloqueados"/>
                    <br>

                    <div v-if="submitted && !cotacaoData.ciddest" class="invalid-feedback">
                      <span>Campo cidade destino obrigatório, favor preencher.</span>
                    </div>
                  </div>
                  <Loader v-if="loadingCidDest || loadingCnpj" style="min-height: 50px;">
                  </Loader>
                </div>
              </div>

              <div class="row mb-2">
                <div class="col-md-6">
                  <div v-if="!loadingCidOri" class="position-relative">
                    <p class="font-weight-semibold mb-2"> Endereço Origem</p>
                    <div class="d-flex">
                      <div class="col-md-4">
                        <p><span class="font-weight-semibold font-size-12">Logradouro: </span>
                          {{ cotacaoData.logrori }} <br>
                          <span class="font-weight-semibold font-size-12">Complemento: </span>
                          {{ cotacaoData.complori }} <br>
                          <span class="font-weight-semibold font-size-12">Bairro: </span> {{ cotacaoData.bairroori }}
                          <br>
                          <span class="font-weight-semibold font-size-12">Cidade/UF: </span> {{ cotacaoData.cidori }} -
                          {{ cotacaoData.ufori }} <br>
                          <span class="font-weight-semibold font-size-12">Cep: </span> {{ cotacaoData.cepori }}
                        </p>
                      </div>
                      <div>
                        <label for="nroori" class="font-weight-semibold font-size-12">Número: </label>
                        <input id="nroori" type="text" size="10" style="font-size: 12px" v-model="cotacaoData.nroori"
                               @change="alterouCampoCotacao('nroori')"
                               :class="{ 'is-invalid': submitted && !cotacaoData.nroori }" class="form-control"
                               placeholder="Número" :disabled="camposBloqueados"/>
                      </div>
                    </div>
                    <div v-if="submitted && !cotacaoData.nroori" class="invalid-feedback">
                      <span>Campo cidade origem obrigatório, favor preencher.</span>
                    </div>
                  </div>
                  <Loader v-if="loadingCidOri" style="min-height: 50px;">
                  </Loader>
                </div>

                <div class="col-md-6">
                  <div v-if="!loadingCidDest && !loadingCnpj" class="position-relative">
                    <p class="font-weight-semibold mb-2"> Endereço Destino</p>
                    <div class="d-flex">
                      <div class="col-md-4">
                        <p><span class="font-weight-semibold font-size-12">Logradouro: </span>
                          {{ cotacaoData.logrdest }} <br>
                          <span class="font-weight-semibold font-size-12">Complemento: </span>
                          {{ cotacaoData.compldest }} <br>
                          <span class="font-weight-semibold font-size-12">Bairro: </span> {{ cotacaoData.bairrodest }}
                          <br>
                          <span class="font-weight-semibold font-size-12">Cidade/UF: </span> {{ cotacaoData.ciddest }} -
                          {{ cotacaoData.ufdest }} <br>
                          <span class="font-weight-semibold font-size-12">Cep: </span> {{ cotacaoData.cepdest }}
                        </p>
                      </div>
                      <div>
                        <label for="nrodest" class="font-weight-semibold font-size-12">Número: </label>
                        <input id="nrodest" type="text" size="10" style="font-size: 12px"
                               v-model="cotacaoData.nrodest"
                               @change="cotacaoData.nrodest_manual = true; alterouCampoCotacao('nrodest')"
                               :class="{ 'is-invalid': submitted && !cotacaoData.ciddest }"
                               class="form-control" placeholder="Número"/>
                      </div>
                    </div>
                    <div v-if="submitted && !cotacaoData.ciddest" class="invalid-feedback">
                      <span>Campo cidade destino obrigatório, favor preencher.</span>
                    </div>
                  </div>
                  <Loader v-if="loadingCidDest || loadingCnpj" style="min-height: 50px;">
                  </Loader>
                </div>
              </div>

              <div class="row mb-4">
                <div class="col-md-2">
                  <label for="cnpj">Data de Coleta:</label>
                  <div class="position-relative">
                    <input id="dtcoleta" type="date" size="10" style="font-size: 12px; height: 50px;"
                           v-model="cotacaoData.dtcoleta" @change="alterouDtColeta"
                           :class="{ 'is-invalid': submitted && !cotacaoData.ciddest }"
                           class="form-control" placeholder="Data de Coleta"/>
                  </div>
                </div>

                <div class="col-md-6">
                  <label for="nome">Obs de Coleta:</label>
                  <div class="position-relative">
                    <input id="obscoleta" type="text" size="10" style="font-size: 12px; height: 50px;"
                           v-model="cotacaoData.obscoleta" class="form-control" placeholder="Observação de Coleta"/>
                  </div>
                </div>
              </div>

              <!-- <div class="row mt-5">
                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="servcorreios">Serviço Cotação CORREIOS</label>
                    <multiselect id="servcorreios"
                                 @search-change="pesqCorreioServico"
                                 v-model="cotacaoData.codserv"
                                 placeholder="Pesquisar serviços"
                                 :options="dtListPesqCorreioServico"
                                 :searchable="true"
                                 label="descricao"
                                 track-by="descricao"
                                 value-prop="codigo">
                      <template #option="slotProps">
                        <div class="row">
                          <div>
                        <span class="text-info">
                          {{ slotProps.option.codigo }}
                        </span>
                            <span class="mx-4">
                        </span>
                          </div>
                          <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>
                          <span class="mx-4"></span>
                          <span class="mx-4"></span>
                          <div class="align-items-end text-end align-content-end">
                            {{ formatDateTime(slotProps.option.created_at) }}
                          </div>
                        </div>
                      </template>
                    </multiselect>
                  </div>
                </div>
              </div> -->

            </b-card-body>

            <hr>

            <b-card-body id="bCardInfoMerc">

                <div class="d-flex">
                  <h5 class="mb-4"> Informações da mercadoria, volumes e embalagens</h5>
                </div>

                <div class="row mb-5">

                  <div class="col-md-3 text-end">
                    <label for="valornf">Valor Nota Fiscal (R$)</label>
                    <div class="position-relative">
                      <input id="valornf" type="number" v-model="cotacaoData.valornf" class="form-control text-end"
                             @change="alterouCampoCotacao('valornf')"
                             placeholder="Valor Nota Fiscal (R$)" :disabled="camposBloqueados"/>
                    </div>
                  </div>

                  <div class="col-md-3 text-end">
                    <label for="peso">Peso Inf. (Kg)</label>
                    <div class="position-relative">
                      <input id="peso" type="number" v-model="cotacaoData.peso" class="form-control text-end"
                             @change="alterouCampoCotacao('peso')"
                             placeholder="Peso Inf. (Kg)" :disabled="camposBloqueados"/>
                    </div>
                  </div>

                  <div class="col-md-3 text-end">
                    <label for="qtdvol">Qtd. Volumes</label>
                    <div class="position-relative">
                      <input id="qtdvol" type="number" v-model="cotacaoData.qtdvol" class="form-control text-end"
                             @change="alterouCampoCotacao('qtdvol')"
                             placeholder="Qtd. Volumes" :disabled="camposBloqueados"/>
                    </div>
                  </div>

                  <div class="col-md-3 text-end">
                    <label for="dimen">Total Dimensões (m³)</label>
                    <div class="position-relative">
                      <input id="dimen" type="number" v-model="cotacaoData.dimens" class="form-control text-end"
                             @change="alterouCampoCotacao('dimens')"
                             placeholder="Total Dimensões (m³)" :disabled="camposBloqueados"/>
                    </div>
                  </div>
                </div>

              <div class="row mb-2">
                <div>
                  <table class="table align-middle table-nowrap">
                    <thead class="table-light">
                      <tr>
                        <th class="align-middle">ID</th>
                        <th class="align-middle text-end">Largura (cm)</th>
                        <th class="align-middle text-end">Altura (cm)</th>
                        <th class="align-middle text-end">Comprimento (cm)</th>
                        <th class="align-middle text-end">Quantidade</th>
                        <th class="align-middle text-end">M. Cúbica</th>
                        <th class="align-middle text-end">Ações</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr v-for="data in cotaFrtVolumes" :key="data.id">
                        <td>
                          <a href="javascript: void(0);" class="text-body fw-bold" @click="editar(data.id)">
                            #{{ data.id }}
                          </a>
                        </td>


                        <td class="text-end">{{ formatDecimal(data.largura) }} </td>
                        <td class="text-end">{{ formatDecimal(data.altura) }} </td>
                        <td class="text-end">{{ formatDecimal(data.comprim) }} </td>
                        <td class="text-end">{{ formatDecimal(data.quant) }} </td>
                        <td class="text-end">{{ formatDecimal(data.pesocub) }} </td>

                        <td class="text-end">
                          <div class="button-items" v-if="!camposBloqueados">
                            <b-button variant="outline-danger" @click="deletar(data.id)">
                              <i class="mdi mdi-trash-can d-block font-size-16"></i>
                            </b-button>

                            <b-button variant="outline-warning" @click="editar(data)">
                              <i class="mdi mdi-pencil d-block font-size-16"></i>
                            </b-button>
                          </div>
                        </td>
                      </tr>
                    </tbody>

                    <tfoot class="table-light" v-if="cotaFrtVolumes.length > 0">
                      <tr>
                        <th class="align-middle">TOTAIS</th>
                        <th class="align-middle text-end" colspan="3"></th>
                        <th class="align-middle text-end">{{ formatDecimal(totalQuant) }}</th>
                        <th class="align-middle text-end">{{ formatDecimal(totalMCub) }}</th>
                        <th class="align-middle text-end"></th>
                      </tr>
                    </tfoot>

                  </table>
                </div>

              </div>

              </b-card-body>

              <b-card-body>

                <h5 class="mb-4"> Cotação Selecionada: </h5>

                <div v-if="!updatingCotaInt" class="row mb-2" style="overflow: auto">

                  <table class="table align-middle table-nowrap" ref="tableCotas">
                    <thead class="table-light">
                      <tr>
                        <th class="align-middle">ID</th>
                        <th class="align-middle">Nº Cot. Transp.</th>
                        <th class="align-middle">Status</th>
                        <th class="align-middle text-end">Frete R$</th>
                        <th class="align-middle text-end">Desc.(%)</th>
                        <th class="align-middle text-end">Desc.(R$)</th>
                        <th class="align-middle text-end">Frete %</th>
                        <th class="align-middle text-end">Frete KG</th>
                        <th class="align-middle text-end">Peso Inf./Cub.(Kg)</th>
<!--                        <th class="align-middle text-end">Peso Cub.(Kg)</th>-->
                        <th class="align-middle text-end">Pesos Base Calc./ <br /> Base C. Pedágio</th>
                        <th class="align-middle text-end">Prazo (Dias)</th>
                        <th class="align-middle text-end">Transportadora</th>
                        <th class="align-middle text-end">CNPJ</th>
<!--                        <th class="align-middle text-end">Ações</th>-->
                      </tr>
                    </thead>
                    <tbody v-if="cotacaoDataSelected[0]">
<!--                      <tr v-for="data in freteCotaCalcsData" :key="data.id">-->
                      <tr v-for="data in cotacaoDataSelected" :key="data.id">
                        <td>
                          <a href="javascript: void(0);" class="text-body fw-bold" @click="abrirCotaInt(data)">
                            #{{ data.id }}
                          </a>
                        </td>

                        <td>{{ data.codigo || '-' }}</td>

                        <td>
                          <span class="badge badge-pill badge-soft-success font-size-11" :class="{
                            'badge-soft-info': `${data.status}` === 'AB',
                            'badge-soft-danger': `${data.status}` === 'X',
                            'badge-soft-success': `${data.status}` === 'CO',
                          }">{{ nomeStatus(data.status) }} </span>
                        </td>

                        <td class="text-end">{{ formatDecimal(data.vlrtotalcicms) }}</td>
                        <td class="text-end">{{ formatDecimal(data.percdesc) }}</td>
                        <td class="text-end" :title="data.regrasobs">
                          {{ formatDecimal(data.valdesc) }}
                          <i v-if="data.regrasobs" class="mdi mdi-information-outline text-info ms-1"></i>
                        </td>
                        <td class="text-end">{{ formatDecimal(data.freteperc) }}</td>
                        <td class="text-end">{{ formatDecimal(data.fretekg) }}</td>
                        <td class="text-end">{{ formatDecimal(data.pesoinf) }}
                          <br />
                          {{ formatDecimal(data.pesocubtotal) }}
                        </td>
<!--                        <td class="text-end">{{ formatDecimal(data.pesocubtotal) }}</td>-->
                        <td class="text-end">{{ formatDecimal(data.pesobscalc) }}
                          <br />
                          {{ formatDecimal(data.pesobspdg) }}
                        </td>
                        <td class="text-end">{{ formatInteger(data.prazo) }}</td>
                        <td class="text-end">{{ data.transpnome }}</td>
                        <td class="text-end">{{ data.transpcnpj }}</td>

<!--                        <td class="text-end">
                          <div v-if="data.status === 'AB' && cotacaoData.status === 'AB'" class="button-items">
                            <b-button variant="outline-warning" @click="contratar(data.id)">
                              <i class="bx bx-mail-send d-block font-size-16"></i>
                            </b-button>
                          </div>
                        </td>-->

                      </tr>
                    </tbody>
                  </table>

                </div>


              </b-card-body>


            <b-card-body v-if="cotacaoData.regra">

              <h5 class="mb-4"> Regra de Frete Aplicada: </h5>

              <div class="row mb-5">

                <div class="col-md-3">
                  <label for="regra">Regra</label>
                  <div class="position-relative">
                    <select
                        id="tipo"
                        v-model="cotacaoData.regra"
                        class="form-control"
                        :disabled="camposBloqueados">
                      <option value="API_MIN_PRC">Retornar cotação com menor preço (API)</option>
                      <option value="API_MIN_PRZ">Retornar cotação com menor prazo (API)</option>
                      <option value="API_MIN_PRZ_TOL">Retornar cotação com menor prazo -> x dias de tolerância (API)</option>
                      <option value="API_MIN_PRC_TOL">Retornar cotação com menor prazo -> % tolerância sobre valor (API)</option>
                    </select>
                  </div>
                </div>

                <div class="col-md-3">
                  <label for="rgtrnome">Transportadora</label>
                  <div class="position-relative">
                    <input id="rgtrnome"
                           type="text"
                           v-model="cotacaoData.rgtrnome"
                           class="form-control"
                           :disabled="true"
                           placeholder="Transportadora"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <label for="rgtrcnpj">CNPJ Transp.</label>
                  <div class="position-relative">
                    <input id="rgtrcnpj"
                           type="text"
                           v-model="cotacaoData.rgtrcnpj"
                           class="form-control"
                           :disabled="true"
                           placeholder="CNPJ Transp."/>
                  </div>
                </div>

                <div class="col-md-2 text-end">
                  <label for="rgprazo">Prazo (dias)</label>
                  <div class="position-relative">
                    <input id="rgprazo"
                           type="number"
                           v-model="cotacaoData.rgprazo"
                           class="form-control text-end"
                           :disabled="true"
                           placeholder="Prazo (dias)"/>
                  </div>
                </div>

                <div class="col-md-2 text-end">
                  <label for="rgvalor">Valor (R$)</label>
                  <div class="position-relative">
                    <input id="rgvalor"
                           type="number"
                           v-model="cotacaoData.rgvalor"
                           class="form-control text-end"
                           :disabled="true"
                           placeholder="Valor (R$)"/>
                  </div>
                </div>

              </div>

            </b-card-body>


          </div>
        </div>



      </form>

    </div>


    <b-modal title="Volumes da Cotação" v-model="showModalVolume" size="xl" centered hide-footer>

      <div class="col-md-12">
        <div class="mb-3">
          <!--          <label for="notatipo">Fornecedor encontrado com este CNPJ</label>-->


          <div class="row">
            <div class="row">
              <div class="col-md-1">
                <div class="mb-3">
                  <label>ID</label>
                </div>
              </div>
              <div class="col-md-2">
                <div class="mb-3 text-end">
                  <label>Largura (cm)</label>
                </div>
              </div>
              <div class="col-md-2">
                <div class="mb-3 text-end">
                  <label>Altura (cm)</label>
                </div>
              </div>
              <div class="col-md-2">
                <div class="mb-3 text-end">
                  <label>Compr.(cm)</label>
                </div>
              </div>
              <div class="col-md-2">
                <div class="mb-3 text-end">
                  <label>Quantidade</label>
                </div>
              </div>
              <div class="col-md-2">
                <div class="mb-3 text-end">
                  <label>M. Cúbica</label>
                </div>
              </div>
              <div class="col-md-1 text-end">
              </div>
            </div>
          </div>

          <div v-for="(field, index) in cotaFrtVolumes" :key="field.id" class="row mt-2">
            <div class="col-md-1 text-end">
              <input id="id" v-model="field.id" type="number" class="form-control text-end" placeholder="ID"
                :disabled="true" />
            </div>

            <div class="col-md-2 text-end">
              <input id="largura" v-model="field.largura" type="number" class="form-control text-end"
                placeholder="Largura (cm)" :disabled="camposBloqueados"
                :class="{ 'is-invalid': submittedVolume && !field.largura }" />
              <div v-if="submittedVolume && !field.largura" class="invalid-feedback">
                <span>Campo largura obrigatório, favor preencher.</span>
              </div>
            </div>

            <div class="col-md-2 text-end">
              <input id="altura" v-model="field.altura" type="number" class="form-control text-end"
                placeholder="Altura (cm)" :disabled="camposBloqueados"
                :class="{ 'is-invalid': submittedVolume && !field.altura }" />
              <div v-if="submittedVolume && !field.altura" class="invalid-feedback">
                <span>Campo altura obrigatório, favor preencher.</span>
              </div>
            </div>

            <div class="col-md-2 text-end">
              <input id="comprimento" v-model="field.comprim" type="number" class="form-control text-end"
                placeholder="Comprimento (cm)" :disabled="camposBloqueados"
                :class="{ 'is-invalid': submittedVolume && !field.comprim }" />
              <div v-if="submittedVolume && !field.comprim" class="invalid-feedback">
                <span>Campo comprimento obrigatório, favor preencher.</span>
              </div>
            </div>

            <div class="col-md-2 text-end">
              <input id="quant" v-model="field.quant" type="number" class="form-control text-end"
                placeholder="Quantidade" :disabled="camposBloqueados"
                :class="{ 'is-invalid': submittedVolume && !field.quant }" />
              <div v-if="submittedVolume && !field.quant" class="invalid-feedback">
                <span>Campo quantidade obrigatório, favor preencher.</span>
              </div>
            </div>

            <div class="col-md-2 text-end">
              <input id="quant" v-model="field.pesocub" type="number" :disabled="true" class="form-control text-end"
                placeholder="Peso cubado" />
            </div>


            <div class="col-md-1 text-end">
              <div class="button-items" v-if="!camposBloqueados">

                <b-button variant="outline-danger" @click="deletarVol(index)">
                  <i class="mdi mdi-trash-can d-block font-size-16"></i>
                </b-button>

              </div>
            </div>


          </div>

          <!--          <div class="row mt-2">-->

          <!--            <div class="col-md-3 text-end">-->

          <!--              <b-button variant="outline-info" @click="addVolume">-->
          <!--                <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>-->
          <!--                Novo Volume-->
          <!--              </b-button>-->

          <!--            </div>-->


          <!--          </div>-->

        </div>
      </div>


      <div>


        <div class="text-end mt-5">

          <b-button variant="light" @click="showModalVolume = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>

          <b-button variant="outline-info" class="ms-1" @click="addVolume" v-if="!camposBloqueados">
            <i class="bx bx-plus font-size-16 align-middle me-2"></i>
            Novo Volume
          </b-button>

          <b-button type="submit" variant="success" class="ms-1" @click="confVolume" v-if="!camposBloqueados">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar Alterações
          </b-button>
        </div>

      </div>

    </b-modal>


    <b-modal size="xl"
             title="Cotação de Frete"
             v-model="showModalCotarFrete" centered hide-footer>
      <div class="col-md-12">


        <div class="row" v-if="loadingCotarFrete">
          <div class="col-12 text-center">
            <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
            </b-spinner>
            <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
            </b-spinner>
            <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
            </b-spinner>
          </div>
        </div>

        <b-tabs v-if="!loadingCotarFrete" content-class="mt-3">

          <b-tab title="Cotações" active>
            <span class="badge badge-pill badge-soft-success font-size-11 me-1" v-if="cotaFrtResults && tempoCotacao">
              Interna {{ tempoCotacao }}
            </span>
            <span class="badge badge-pill badge-soft-info font-size-11" v-if="cotaFrtResults && tempoCotacaoExt">
              Externa {{ tempoCotacaoExt }}
            </span>

            <b-alert v-for="(erro, i) in errosCotacao" :key="`alerta-${i}`" show dismissible variant="danger" class="mt-2">
              <i class="mdi mdi-alert me-2"></i>{{ erro.Description }}
            </b-alert>

            <div class="table-responsive mt-2" v-if="cotaFrtResults">
              <table class="table table-centered table-nowrap">
                <thead>
                  <tr>
                    <th scope="col">Ações</th>
                    <th scope="col">ID / Nº Cot. Transp.</th>
                    <th scope="col">TranspNome</th>
                    <th scope="col" class="text-end">Frete R$</th>
                    <th scope="col" class="">Frete %</th>
                    <th scope="col" class="">Frete KG</th>
                    <th class="align-middle text-end">Peso Inf./Cub.(Kg)</th>
                    <th scope="col" class="text-end">PrazoDias</th>
                    <th scope="col">TranspCNPJ</th>
                    <th scope="col" class="text-center">Logo</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="data in cotaFrtResults" :key="data.id">
                    <td :class="{'text-info': data.id === cotacaoData.cotaid}">
                      <a v-if="data.id === cotacaoData.cotaid" href="javascript:void(0);" v-b-tooltip.hover class="action-icon text-info mx-2"
                         title="Cotação Escolhida">
                        <i class="mdi mdi-check-circle font-size-18"></i>
                      </a>
                      <a v-else href="javascript:void(0);" v-b-tooltip.hover class="action-icon text-info mx-2"
                         title="Escolher Transportadora" @click="cotacaoselected(data)">
                        <i class="mdi mdi-check-outline font-size-18"></i>
                      </a>
                      <a href="javascript:void(0);" v-b-tooltip.hover class="action-icon text-success mx-2"
                         title="Detalhes Cotação" @click="abrirCotaInt(data)">
                        <i class="mdi mdi-eye-circle font-size-18"></i>
                      </a>
                    </td>
                    <td :class="{'text-info': data.id === cotacaoData.cotaid}">
                      {{ data.codigo || data.id }}
                    </td>
                    <td :class="{'text-info': data.id === cotacaoData.cotaid}">
                      {{ data.transpnome }}
                      <!-- Termo da cotação externa: hoje só os Correios preenchem,
                           quando a quantidade de volumes foi estimada (chamado 2166). -->
                      <a v-if="data.obs" href="javascript:void(0);" v-b-tooltip.hover class="action-icon text-warning ms-1"
                         :title="data.obs">
                        <i class="mdi mdi-alert-circle-outline font-size-18"></i>
                      </a>
                    </td>
                    <td class="text-end" :class="{'text-info': data.id === cotacaoData.cotaid}">
                      <i class="bx bxs-dollar-circle font-size-18 bx-fade-right text-success" v-if="data.menorvalor"></i>
                      {{ formatDecimal(data.vlrtotalcicms) }}
                    </td>
                    <td class="text-end" :class="{'text-info': data.id === cotacaoData.cotaid}">
                      <i class="bx bxs-dollar-circle font-size-18 bx-fade-right text-success" v-if="data.menorvalor"></i>
                      {{ formatDecimalDois(data.freteperc) }}
                    </td>
                    <td class="text-end" :class="{'text-info': data.id === cotacaoData.cotaid}">
                      <i class="bx bxs-dollar-circle font-size-18 bx-fade-right text-success" v-if="data.menorvalor"></i>
                      {{ formatDecimal(data.fretekg) }}
                    </td>
                    <td class="text-end" :class="{'text-info': data.id === cotacaoData.cotaid}">
                      <i class="bx bxs-dollar-circle font-size-18 bx-fade-right text-success" v-if="data.menorvalor"></i>
                      {{ formatDecimal(data.pesoinf) }}<br />
                      {{ formatDecimal(data.pesocubtotal) }}
                    </td>
                    <td class="text-end" :class="{'text-info': data.id === cotacaoData.cotaid}">
                      <i class="bx bxs-calendar font-size-18 bx-fade-right text-info" v-if="data.menorprazo"></i>
                      {{ data.prazo }}
                    </td>
                    <td :class="{'text-info': data.id === cotacaoData.cotaid}">{{ data.transpcnpj }}</td>
                    <td class="text-center" :class="{'text-info': data.id === cotacaoData.cotaid}">
                      <a href="javascript: void(0);" style="max-height: 10px;">
                        <img :src="getImgUrl(data.transpcnpj)" alt height="35" />
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <p v-if="!loadingCotarFrete && !cotaFrtResults && errosCotacao === null" class="text-muted text-center mt-3">
              Nenhuma cotação encontrada.
            </p>
          </b-tab>

          <b-tab v-if="falhasCotacao.length > 0 && userLogged && userLogged.tipo === 'admin'">
            <template #title>
              Falhas <b-badge variant="danger" class="ms-1">{{ falhasCotacao.length }}</b-badge>
            </template>
            <ul class="list-group list-group-flush mt-2">
              <li v-for="(falha, i) in falhasCotacao" :key="`falha-${i}`"
                  class="list-group-item d-flex justify-content-between align-items-start">
                <div>
                  <i class="mdi mdi-alert-circle text-warning me-2" v-if="falha.tipo === 'sem_token' || falha.tipo === 'sem_base' || falha.tipo === 'acima_peso_max'"></i>
                  <i class="mdi mdi-close-circle text-danger me-2" v-else></i>
                  <strong v-if="falha.transportadora">{{ falha.transportadora }}</strong>
                  <strong v-else>Cotação Interna</strong>
                  <span class="ms-2 text-muted">{{ falha.mensagem }}</span>
                </div>
                <b-button v-if="falha.json !== null" size="sm" variant="outline-secondary"
                          @click="abrirJsonFalha(falha)">
                  Ver JSON
                </b-button>
              </li>
            </ul>
          </b-tab>

        </b-tabs>

        <div v-if="!loadingCotarFrete">
          <div class="text-end mt-5">
            <b-button variant="info" @click="cotarFreteEconoPro">
              <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
              Nova Cotação
            </b-button>

            <b-button variant="light" @click="showModalCotarFrete = false">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Fechar
            </b-button>
          </div>
        </div>
      </div>

    </b-modal>

    <b-modal v-model="showModalJson" title="JSON de Retorno da API" size="lg">
      <pre class="bg-light p-3 rounded" style="max-height: 400px; overflow-y: auto; font-size: 12px;">{{ JSON.stringify(jsonModalData, null, 2) }}</pre>
      <template #modal-footer="{ ok }">
        <b-button variant="secondary" @click="copiarJsonFalha()">
          Copiar
        </b-button>
        <b-button variant="primary" @click="ok()">Fechar</b-button>
      </template>
    </b-modal>


    <b-modal size="md" :title="`Detalhes Cotação Interna ${cotaFreteData.id}`" v-model="showModalCotaInt" centered
      hide-footer>
      <div class="col-md-12">


        <div class="row">
          <div class="table-responsive">
            <table class="table table-sm  mb-0">
              <tbody>
                <tr class="table-success">
                  <td>Frete Peso</td>
                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.fretepeso) }}</td>
                </tr>
                <tr class="table-success">
                  <td>FQM/Peso</td>
                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.percnfkg) }}</td>
                </tr>
                <tr class="table-success">
                  <td>Valor Peso Adicional</td>
                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.fretepesoext) }}</td>
                </tr>
                <tr class="table-success">
                  <td>Frete Valor (%)</td>
                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.fretevalor) }}</td>
                </tr>
                <tr class="table-success">
                  <td>GRIS (%)</td>
                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.gris) }}</td>
                </tr>
                <tr class="table-success">
                  <td>TAS Valor Fixo</td>
                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.tasvlrfixo) }}</td>
                </tr>
                <tr class="table-success">
                  <td>Despacho Valor Fixo</td>
                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.despachovlrfixo) }}</td>
                </tr>
                <tr class="table-success">
                  <td>Taxa Seguro Obrigatório (%)</td>
                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.txsegobrig) }}</td>
                </tr>
                <tr class="table-success" v-if="cotaFreteData.txpesfis > 0">
                  <td>Taxa Pessoa Física (R$)</td>
                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.txpesfis) }}</td>
                </tr>
                <tr class="table-light">
                  <td colspan="1" class="text-black text-end">SubTotal #1</td>
                  <td class="text-black text-end font-size-14">{{ formatDecimalQuatro(cotaFreteData.subtotal1) }}</td>
                </tr>
                <tr class="table-warning">
                  <td>TSB (%)</td>
                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.tsbperc) }}</td>
                </tr>
                <tr class="table-warning">
                  <td>TSB Valor Fixo</td>
                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.tsbvlrfixo) }}</td>
                </tr>
                <tr class="table-warning">
                  <td>Suframa Valor Fixo</td>
                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.suframavlrfixo) }}</td>
                </tr>
                <tr class="table-warning">
                  <td>Seguro Fluvial (%)</td>
                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.segfluvperc) }}</td>
                </tr>
                <tr class="table-warning">
                  <td>Seguro Fluvial Valor Fixo</td>
                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.segfluvvlrfixo) }}</td>
                </tr>
                <tr class="table-light">
                  <td colspan="1" class="text-black text-end">SubTotal #2</td>
                  <td class="text-black text-end font-size-14">{{ formatDecimalQuatro(cotaFreteData.subtotal2) }}</td>
                </tr>

                <tr class="table-warning">
                  <td>Taxa Reajuste Valor Fixo</td>
                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.txreajvlrfixo) }}</td>
                </tr>


                <tr class="table-warning">
                  <td>Pedágio Valor Fixo</td>
                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.pedagiovlrfixo) }}</td>
                </tr>
                <tr class="table-warning">
                  <td>Pedágio Fração a Cada 100Kg</td>
                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.pedagiofrac100kg) }}</td>
                </tr>
                <tr class="table-warning">
                  <td>Pedágio por Kg</td>
                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.pedagiovlrkg) }}</td>
                </tr>
                <tr class="table-warning">
                  <td>Coleta Valor Fixo</td>
                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.coletavlrfixo) }}</td>
                </tr>
                <tr class="table-warning">
                  <td>Coleta por Kg</td>
                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.coletavlrkg) }}</td>
                </tr>
                <tr class="table-warning">
                  <td>Entrega Valor Fixo</td>
                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.entregavlrfixo) }}</td>
                </tr>
                <tr class="table-warning">
                  <td>Entrega por Kg</td>
                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.entregavlrkg) }}</td>
                </tr>
                <tr class="table-warning">
                  <td>SECCAT Valor Fixo</td>
                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.seccatvlrfixo) }}</td>
                </tr>
                <tr class="table-warning">
                  <td>ADEME (%)</td>
                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.ademeperc) }}</td>
                </tr>
                <tr class="table-warning">
                  <td>ADEME Valor Fixo</td>
                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.ademevlrfixo) }}</td>
                </tr>
                <tr class="table-warning">
                  <td>EMEX (%)</td>
                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.emexperc) }}</td>
                </tr>
                <tr class="table-warning">
                  <td>EMEX Valor Fixo</td>
                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.emexvlrfixo) }}</td>
                </tr>
                <tr class="table-warning">
                  <td>EMEX Fração a Cada 100Kg</td>
                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.emexfrac100kg) }}</td>
                </tr>
                <tr class="table-warning">
                  <td>EMEX por Kg</td>
                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.emexvlrkg) }}</td>
                </tr>
                <tr class="table-light">
                  <td colspan="1" class="text-black text-end">SubTotal #3</td>
                  <td class="text-black text-end font-size-14">{{ formatDecimalQuatro(cotaFreteData.subtotal3) }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="text-center">
            <h5 class="mt-3">FRETE COMPARAÇÃO</h5>
          </div>
          <div class="table-responsive">
            <table class="table table-sm  mb-0">
              <tbody>
                <tr class="table-warning">
                  <td>(%) Sobre NF</td>
                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.frtcomppercnota) }}</td>
                </tr>
<!--                <tr class="table-warning">-->
<!--                  <td>(%) Sobre NF (+ Taxas)</td>-->
<!--                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.frtcomppercnotares) }}</td>-->
<!--                </tr>-->
                <tr class="table-warning">
                  <td>Frete KG</td>
                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.frtcompkg) }}</td>
                </tr>
                <tr class="table-warning">
                  <td>Frete Mínimo</td>
                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.frtcompmin) }}</td>
                </tr>
<!--                <tr class="table-warning">-->
<!--                  <td>Total sem ICMS</td>-->
<!--                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.frtcompsicms) }}</td>-->
<!--                </tr>-->
<!--                <tr class="table-warning">-->
<!--                  <td>Total com ICMS</td>-->
<!--                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.frtcompcicms) }}</td>-->
<!--                </tr>-->
                <tr class="table-warning">
                  <td>Comparativo (% x KG)</td>
                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.frtcompminres) }}</td>
                </tr>
              </tbody>
            </table>
          </div>


            <div class="table-responsive">
              <table class="table table-sm  mb-0">
                <tbody>
                <tr class="table-light">
                  <td colspan="1" class="text-black text-end">SubTotal #4</td>
                  <td class="text-black text-end font-size-14">{{ formatDecimalQuatro(cotaFreteData.subtotal4) }}</td>
                </tr>

                <tr class="table-light">
                  <td colspan="1" class="text-black text-end">SubTotal #5</td>
                  <td class="text-black text-end font-size-14">{{ formatDecimalQuatro(cotaFreteData.subtotal5) }}</td>
                </tr>

                <tr class="table-info">
                  <td>TDA</td>
                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.valortda) }}</td>
                </tr>
                <tr class="table-info">
                  <td>TDA Fixo</td>
                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.valortdafixo) }}</td>
                </tr>
                <tr class="table-info">
                  <td>TDE</td>
                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.valortde) }}</td>
                </tr>
                <tr class="table-info">
                  <td>TDE Fixo</td>
                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.valortdefixo) }}</td>
                </tr>
                <tr class="table-info">
                  <td>Taxa de Agendamento</td>
                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.txagenda) }}</td>
                </tr>

                <tr class="table-info" v-for="data in freteCotaCalcAdicsFiltData" :key="data.id">
                  <td>{{ data.descricao }}</td>
                  <td class="text-end">{{ formatDecimalQuatro(data.valor) }}</td>
                </tr>

                <tr class="table-light">
                  <td colspan="1" class="text-black text-end">SubTotal #6</td>
                  <td class="text-black text-end font-size-14">{{ formatDecimalQuatro(cotaFreteData.subtotal6) }}</td>
                </tr>
                <tr class="table-light">
                  <td colspan="1" class="text-black text-end">SubTotal #7</td>
                  <td class="text-black text-end font-size-14">{{ formatDecimalQuatro(cotaFreteData.subtotal7) }}</td>
                </tr>
                <tr class="table-info">
                  <td>TRT</td>
                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.valortrt) }}</td>
                </tr>
                <tr class="table-info">
                  <td>TRT Fixo</td>
                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.valortrtfixo) }}</td>
                </tr>

                <tr class="table-light">
                  <td colspan="1" class="text-black text-end">SubTotal #8</td>
                  <td class="text-black text-end font-size-14">{{ formatDecimalQuatro(cotaFreteData.subtotal8) }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="table-responsive">
            <table class="table table-sm  mb-0">
              <tbody>

              <tr class="table-danger">
                <td>Taxa Reajuste Porcentagem</td>
                <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.txreajvlrperc) }}</td>
              </tr>

              <tr class="table-danger">
                <td>ADM RODO (%)</td>
                <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.admrodopercfrete) }}</td>
              </tr>

              <tr class="table-danger">
                <td>Frete Total SEM ICMS</td>
                <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.vlrtotalsicms) }}</td>
              </tr>
              <tr class="table-danger">
                <td>Frete ICMS</td>
                <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.vlricms) }}</td>
              </tr>
              <tr class="table-danger">
                <td>Frete Total COM ICMS</td>
                <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.vlrtotalcicms) }}</td>
              </tr>
              </tbody>
            </table>
          </div>


<!--          <div class="text-center">-->
<!--            <h5 class="mt-3">FRETE COMPARAÇÃO</h5>-->
<!--          </div>-->
<!--          <div class="table-responsive">-->
<!--            <table class="table table-sm  mb-0">-->
<!--              <tbody>-->
<!--                <tr class="table-warning">-->
<!--                  <td>(%) Sobre NF</td>-->
<!--                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.frtcomppercnota) }}</td>-->
<!--                </tr>-->
<!--                <tr class="table-warning">-->
<!--                  <td>(%) Sobre NF (+ Taxas)</td>-->
<!--                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.frtcomppercnotares) }}</td>-->
<!--                </tr>-->
<!--                <tr class="table-warning">-->
<!--                  <td>Frete KG</td>-->
<!--                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.frtcompkg) }}</td>-->
<!--                </tr>-->
<!--                <tr class="table-warning">-->
<!--                  <td>Frete Mínimo</td>-->
<!--                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.frtcompmin) }}</td>-->
<!--                </tr>-->
<!--                <tr class="table-warning">-->
<!--                  <td>Total sem ICMS</td>-->
<!--                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.frtcompsicms) }}</td>-->
<!--                </tr>-->
<!--                <tr class="table-warning">-->
<!--                  <td>Total com ICMS</td>-->
<!--                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.frtcompcicms) }}</td>-->
<!--                </tr>-->
<!--                <tr class="table-warning">-->
<!--                  <td>Comparativo (% x KG)</td>-->
<!--                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.frtcompminres) }}</td>-->
<!--                </tr>-->
<!--              </tbody>-->
<!--            </table>-->
<!--          </div>-->
          <div class="text-center">
            <h5 class="mt-3">CUBAGEM</h5>
          </div>
          <div class="table-responsive">
            <table class="table table-sm  mb-0">
              <tbody>
                <tr class="table-warning">
                  <td>FT. Cub.</td>
                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.cubft) }}</td>
                </tr>
                <tr class="table-warning">
                  <td>Peso Informado</td>
                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.pesoinf) }}</td>
                </tr>
                <tr class="table-warning">
                  <td>M. Cúbico</td>
                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.mcubic) }}</td>
                </tr>
                <tr class="table-warning">
                  <td>Peso Cubado Total</td>
                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.pesocubtotal) }}</td>
                </tr>
                <tr class="table-warning">
                  <td>Peso Base Cálculo</td>
                  <td class="text-end">{{ formatDecimalQuatro(cotaFreteData.pesobscalc) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <hr />
        <div class="row">

          <div class="col-4">
            <div>
              <p class="text-muted text-truncate mb-2">Prazo</p>
              <h5 class="mb-0">{{ formatInteger(cotaFreteData.prazo) }}</h5>
            </div>
          </div>

          <div class="col-4">
            <div>
              <p class="text-muted text-truncate mb-2">Tabela</p>
<!--              <h5 class="mb-0">{{ cotaFreteData.fretecotabase_id }}</h5>-->

<!--              <router-link :to="`/cotacaofretesbase/editar/${cotaFreteData.fretecotabase_id}`">-->
<!--&lt;!&ndash;                <button type="button" class="btn btn-success btn-rounded mb-2 me-2" >&ndash;&gt;-->
<!--&lt;!&ndash;                  <i class="mdi mdi-plus me-1"></i> Novo Projeto&ndash;&gt;-->
<!--&lt;!&ndash;                </button>&ndash;&gt;-->

<!--                <h5 class="mb-0">{{ cotaFreteData.fretecotabase_id }}</h5>-->

<!--              </router-link>-->


              <a href="javascript: void(0);" @click="abrirTabela(cotaFreteData.fretecotabase_id)" class="text-body fw-bold">
                {{ cotaFreteData.fretecotabase_id }}</a>


            </div>




          </div>


        </div>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalCotaInt = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Fechar
          </b-button>
        </div>
      </div>

    </b-modal>

    <b-modal title="Origens Empresa (selecione a origem que deseja)" v-model="showModalOrigem" size="xl" centered hide-footer>
      <div class="row">
        <div class="col-md-12">
          <table class="table align-middle table-nowrap">
            <thead class="table-light">
            <tr>
              <th class="align-middle">ID</th>
              <th class="align-middle">CEP</th>
              <th class="align-middle">Logradouro</th>
              <th class="align-middle">Número</th>
              <th class="align-middle">Bairro</th>
              <th class="align-middle">Cidade</th>
              <th class="align-middle">Ações</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in emprOrigensData" :key="data.id">

              <td>
                <a href="javascript: void(0);" class="text-body fw-bold" @click="escolherEmprOrigem(data)">
                  #{{ data.id }}
                </a>
              </td>

              <td>{{ data.cep }} </td>
              <td>{{ data.rua }} </td>
              <td>{{ data.numero }} </td>
              <td>{{ data.bairro }} </td>
              <td>{{ data.cidade }} </td>
              <td>
                <div class="button-items">
                  <b-button variant="outline-warning" @click="escolherEmprOrigem(data)">
                    <i class="mdi mdi-hand d-block font-size-16"></i>
                  </b-button>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div>
        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalOrigem = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal size="xl"
             title="Cotação de Frete (V)"
             v-model="showModalCotacaoApi" centered hide-footer>
      <div class="col-md-12">


        <div class="row" v-if="loadingCotarFrete">
          <div class="col-12 text-center">
            <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
            </b-spinner>
            <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
            </b-spinner>
            <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
            </b-spinner>
          </div>
        </div>


        <b-alert v-for="(erro, i) in errosCotacao" :key="`alerta-${i}`" show dismissible variant="danger">
          <i class="mdi mdi-alert me-2"></i>{{ erro.Description }}
        </b-alert>

        <div class="table-responsive" v-if="cotacaoIntExtApi">
          <table class="table table-centered table-nowrap">
            <thead>
            <tr>
              <th scope="col">Ações</th>
              <th scope="col">Status</th>
              <th scope="col" class="text-center">ID / Nº Cot. Transp.</th>
              <th scope="col" class="text-center">TranspNome</th>
              <th scope="col" class="text-center">Frete R$</th>
              <th scope="col" class="text-center">Frete %</th>
              <th scope="col" class="text-center">Frete KG</th>
              <th class="align-middle text-end">Peso Inf./Cub.(Kg)</th>
              <th scope="col" class="text-center">Peso Base Calc.</th>
              <th scope="col" class="text-center">Prazo (Dias)</th>
              <th scope="col" class="text-center">TranspCNPJ</th>
              <th scope="col" class="text-center">Logo</th>
              <!--            <th scope="col">TranspEmail</th>-->
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in cotacaoIntExtApi" :key="data.id">
              <td class="text-center" :class="{'text-info': data.id === cotacaoData.cotaid}">

                <a v-if="data.id === cotacaoData.cotaid" href="javascript:void(0);" v-b-tooltip.hover class="action-icon text-info mx-2"
                   title="Cotação Escolhida">
                  <i class="mdi mdi-check-circle font-size-18"></i>
                </a>
                <a v-else href="javascript:void(0);" v-b-tooltip.hover class="action-icon text-info mx-2"
                   title="Escolher Transportadora" @click="cotacaoselected(data)">
                  <i class="mdi mdi-check-outline font-size-18"></i>
                </a>

              </td>

              <td class="text-center" :class="{'text-info': data.id === cotacaoData.cotaid}">
                <a v-if="data.regraret" href="javascript:void(0);" v-b-tooltip.hover class="action-icon text-success mx-2"
                   :title="'Esta linha foi retornada como resultado na API: ' + data.regraret">
                  <i class="mdi mdi-check-circle font-size-18"></i>
                </a>
              </td>

              <td class="text-center" :class="{'text-info': data.id === cotacaoData.cotaid}">
                {{ data.codigo || data.id }}
              </td>

              <td class="text-center" :class="{'text-info': data.id === cotacaoData.cotaid}">
                {{ data.transpnome }}
                <!-- Termo da cotação externa: hoje só os Correios preenchem,
                     quando a quantidade de volumes foi estimada (chamado 2166). -->
                <a v-if="data.obs" href="javascript:void(0);" v-b-tooltip.hover class="action-icon text-warning ms-1"
                   :title="data.obs">
                  <i class="mdi mdi-alert-circle-outline font-size-18"></i>
                </a>
              </td>

              <td class="text-center" :class="{'text-info': data.id === cotacaoData.cotaid}">
                <i class="bx bxs-dollar-circle font-size-18 bx-fade-right text-success" v-if="data.menorvalor"></i>
                {{ formatDecimal(data.vlrtotalcicms) }}
              </td>

              <td class="text-center" :class="{'text-info': data.id === cotacaoData.cotaid}">
                <i class="bx bxs-dollar-circle font-size-18 bx-fade-right text-success" v-if="data.menorvalor"></i>
                {{ formatDecimal(data.freteperc) }}
              </td>

              <td class="text-center" :class="{'text-info': data.id === cotacaoData.cotaid}">
                <i class="bx bxs-dollar-circle font-size-18 bx-fade-right text-success" v-if="data.menorvalor"></i>
                {{ formatDecimal(data.fretekg) }}
              </td>

              <td class="text-center" :class="{'text-info': data.id === cotacaoData.cotaid}">
                <i class="bx bxs-dollar-circle font-size-18 bx-fade-right text-success" v-if="data.menorvalor"></i>
                {{ formatDecimal(data.peso) }}
                <br/>
                {{ formatDecimal(data.pesocubtotal) }}
              </td>


              <td class="text-center" :class="{'text-info': data.id === cotacaoData.cotaid}">
                <i class="bx bxs-dollar-circle font-size-18 bx-fade-right text-success" v-if="data.menorvalor"></i>
                {{ formatDecimal(data.pesobscalc) }}
              </td>

              <td class="text-center" :class="{'text-info': data.id === cotacaoData.cotaid}">
                <i class="bx bxs-calendar font-size-18 bx-fade-right text-info" v-if="data.menorprazo"></i>
                {{ data.prazo }}
              </td>

              <td class="text-center" :class="{'text-info': data.id === cotacaoData.cotaid}">
                {{ data.transpcnpj }}
              </td>

              <td class="text-center" :class="{'text-info': data.id === cotacaoData.cotaid}">

                <a href="javascript: void(0);" style="max-height: 10px;">

                  <!-- <img :src="require('@/assets/images/logotransp/' + data.WSOut_Transp_CNPJ + '.png')" alt height="35"  />-->
                  <img :src="getImgUrl(data.transpcnpj)" alt height="35" />

                </a>

              </td>


            </tr>

            </tbody>
          </table>
        </div>


        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalCotacaoApi = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Fechar
          </b-button>

        </div>
      </div>

    </b-modal>



    <b-modal size="xl" title="Cotação de Frete Sob Demanda" v-model="showModalCotDemanda" centered hide-footer>
      <div class="col-md-12">

        <div class="row" v-if="loadingCotarFrete">
          <div class="col-12 text-center">
            <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
            </b-spinner>
            <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
            </b-spinner>
            <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
            </b-spinner>
          </div>
        </div>

        <b-alert v-for="(erro, i) in errosCotacao" :key="`alerta-${i}`" show dismissible variant="danger">
          <i class="mdi mdi-alert me-2"></i>{{ erro.Description }}
        </b-alert>

        <div class="table-responsive" v-if="freteCotaCalcDemsData && !loadingCotarFrete">
          <table class="table table-centered table-nowrap">
            <thead>
            <tr>
              <th scope="col">Ações</th>
              <th scope="col" class="text-left">ID</th>
              <th scope="col" class="text-left">Status</th>
              <th scope="col" class="text-left text-wrap" style="width: 150px;">TranspNome</th>
              <th scope="col" class="text-end">Frete R$</th>
              <th scope="col" class="text-end">Frete % / KG</th>
              <th scope="col" class="text-end">Peso(kg) Inf./Cub.</th>
              <th scope="col" class="text-end">Prazo (Dias)</th>
              <th scope="col" class="text-left">TranspCNPJ</th>
              <th scope="col" class="text-end">Env./Resp.</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in freteCotaCalcDemsData" :key="data.id">
              <td class="text-left" :class="{'text-info': data.id === cotacaoData.cotaid}">
                <a href="javascript:void(0);" v-b-tooltip.hover class="action-icon text-danger mx-2"
                   @click="deletarCotaDem(data.id)"
                   title="Excluir Transportadora">
                  <i class="mdi mdi-trash-can font-size-18"></i>
                </a>
              </td>
              <td class="text-left text-wrap" >
                {{ data.id }}
              </td>
              <td class="text-left text-wrap" >
                <span class="badge badge-pill badge-soft-success font-size-11" :class="{
                            'badge-soft-warning': `${data.status}` === 'NE',
                            'badge-soft-info': `${data.status}` === 'EV',
                            'badge-soft-danger': `${data.status}` === 'X',
                            'badge-soft-success': `${data.status}` === 'CO'}">
                  {{ nomeStatusCotaDem(data.status) }}
                </span>
              </td>
              <td class="text-left text-wrap" :class="{'text-info': data.id === cotacaoData.cotaid}" style="width: 150px;">
                {{ data.transpnome }}
              </td>
              <td class="text-end" :class="{'text-info': data.id === cotacaoData.cotaid}">
                <i class="bx bxs-dollar-circle font-size-18 bx-fade-right text-success" v-if="data.menorvalor"></i>
                {{ formatDecimal(data.fretevalor) }}
              </td>
              <td class="text-end" :class="{'text-info': data.id === cotacaoData.cotaid}">
                <i class="bx bxs-dollar-circle font-size-18 bx-fade-right text-success" v-if="data.menorvalor"></i>
                {{ formatDecimal(data.freteperc) }}
                <br/>
                {{ formatDecimal(data.fretepeso) }}
              </td>
              <td class="text-end" :class="{'text-info': data.id === cotacaoData.cotaid}">
                <i class="bx bxs-dollar-circle font-size-18 bx-fade-right text-success" v-if="data.menorvalor"></i>
                {{ formatDecimal(data.peso) }}
                <br/>
                {{ formatDecimal(data.pesocub) }}
              </td>
              <td class="text-end" :class="{'text-info': data.id === cotacaoData.cotaid}">
                <i class="bx bxs-calendar font-size-18 bx-fade-right text-info" v-if="data.menorprazo"></i>
                {{ formatDecimal(data.prazo) }}
              </td>
              <td class="text-left" :class="{'text-info': data.id === cotacaoData.cotaid}">
                {{ data.transpcnpj }}
              </td>
              <td class="text-end" :class="{'text-info': data.id === cotacaoData.cotaid}">
                <i class="bx bxs-calendar font-size-18 bx-fade-right text-info" v-if="data.menorprazo"></i>
                {{ data.enviado != null ? formatDateTime(data.enviado) : '' }}
                <br/>
                {{ data.resposta != null ? formatDateTime(data.resposta) : '' }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <div class="row mb-2" v-if="freteCotaCalcDemsData && freteCotaCalcDemsData.length > 0">

          <div class="col-md-3">
            <label for="limitecotadem">Limite Resposta</label>
            <div class="position-relative">
              <input
                  id="limitecotadem"
                  type="datetime-local"
                  v-model="limiteCotaDem"
                  class="form-control"
                  placeholder="Limite Resposta"/>
            </div>
          </div>

        </div>


        <div class="text-end mt-5">

          <b-button variant="light" @click="showModalCotDemanda = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Fechar
          </b-button>

          <b-button variant="outline-success"
                    v-if="freteCotaCalcDemsData && freteCotaCalcDemsData.length > 0 && !loadingCotarFrete"
                    class="ms-2" @click="enviarSoliCota">
            <i class="bx bx-send font-size-16 align-middle me-2"></i>
            Enviar Solicitação de Cotação
          </b-button>

        </div>

      </div>

    </b-modal>

  </Layout>
</template>
